/* ===================================================================
 * Standardformat-Konfigurator ("Geschenke")
 *
 * Schlanke Variante des grossen frame-configurator.js fuer Produkte mit
 * festem Falzmass. Kunde waehlt: Bild + Ausschnitt, Ausrichtung,
 * Passepartout-Farbe, Menge.
 *
 * Wiederverwendet bewusst:
 *   - window.generateFramePreviewSvg (assets/frame-preview-svg.js)
 *   - Firebase-Upload-Flow (identisch zu frame-configurator.js)
 *   - Line-Item-Property-Schema (damit Cart & Produktion unveraendert laufen)
 * =================================================================== */
(function () {
  'use strict';

  /* --- Die vier Passepartout-Farben (Teilmenge von SHARED_MAT_COLOR_OPTIONS) --- */
  var SFC_MAT_COLORS = [
    { color: 'naturweiss', displayName: 'Naturweiß', hex: '#F2ECDF', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Naturweiss_MSK-Naturweiss.png?v=1754908103' },
    { color: 'hellweiss',  displayName: 'Hellweiß',  hex: '#FAF9F5', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Hellweiss_MSK-Hellweiss.png?v=1754908062' },
    { color: 'creme',      displayName: 'Creme',          hex: '#EFE3CC', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Creme_MSK-Creme.png?v=1754908112' },
    { color: 'schwarz',    displayName: 'Schwarz',        hex: '#1C1C1C', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Schwarz_MSK-Schwarz.png?v=1754908109' }
  ];

  var MAX_UPLOAD_BYTES = 25 * 1024 * 1024;
  var ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
  var MIN_CROP_PX = 48;          // Mindestgroesse der Auswahlbox auf dem Bildschirm
  /* Schwellen am fertigen Motiv, nicht am Originalbild.
     Unter LOW wird gedruckt sichtbar unscharf, ab GOOD sitzt es auch aus der
     Naehe. Beide blockieren bewusst NICHT — der Kunde darf immer weiter. */
  var LOW_PRINT_DPI = 150;       // Untergrenze
  var GOOD_PRINT_DPI = 200;      // Empfehlung

  /* =================================================================
   * Kleine Helfer
   * ================================================================= */

  function $(id) { return document.getElementById(id); }

  function readJson(id) {
    var el = $(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) {
      console.error('[SFC] Ungueltiges JSON in #' + id, e);
      return null;
    }
  }

  /**
   * Preisformatierung ueber die Theme-Schicht, damit der Konfigurator dieselbe
   * Schreibweise zeigt wie Warenkorb und Checkout. theme.Currency.formatMoney
   * liest shop.money_format (aktuell "{{amount_no_decimals}}€") aus
   * snippets/js-variables.liquid; eine eigene Intl-Formatierung wich davon ab.
   *
   * Der Fallback greift nur, wenn global.js noch nicht geladen ist — er ist
   * bewusst schlicht und soll im Normalbetrieb nie sichtbar werden.
   */
  function formatMoney(cents) {
    var t = window.theme;
    if (t && t.Currency && typeof t.Currency.formatMoney === 'function' &&
        t.shopSettings && t.shopSettings.moneyFormat) {
      try {
        return t.Currency.formatMoney(cents, t.shopSettings.moneyFormat);
      } catch (e) {
        console.warn('[SFC] theme.Currency.formatMoney fehlgeschlagen, Fallback greift', e);
      }
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function formatCm(value) {
    var rounded = Math.round(value * 10) / 10;
    return String(rounded).replace('.', ',');
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  /** Liefert die Zeigerposition relativ zu einem Element. */
  function pointerPos(event, element) {
    var touch = event.touches && event.touches[0];
    var clientX = touch ? touch.clientX : event.clientX;
    var clientY = touch ? touch.clientY : event.clientY;
    var rect = element.getBoundingClientRect();
    return { x: clientX - rect.left, y: clientY - rect.top };
  }

  function addWorkdays(startDate, days) {
    var date = new Date(startDate.getTime());
    var added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      var day = date.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return date;
  }

  function formatDateShort(date) {
    var months = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'];
    return date.getDate() + '. ' + months[date.getMonth()];
  }

  /* =================================================================
   * Format-Mathematik
   *
   * Eine Rahmung ist ein Passepartout-Blatt mit einem oder mehreren
   * gleich grossen Fenstern. Alle Masse stehen im Varianten-Metafeld
   * custom.pp_masse und kommen in cm herein:
   *
   *   aussen {b,h}        Blattmass in seiner tatsaechlichen Ausrichtung
   *   raster {spalten,zeilen}
   *   ausschnitt {b,h}    Mass EINES Fensters
   *   steg                Abstand zwischen zwei Fenstern
   *   rand_lr, rand_ou    Rand links=rechts bzw. oben=unten
   *
   * Es geht immer auf:
   *   2*rand_lr + spalten*ausschnitt.b + (spalten-1)*steg = aussen.b
   * ================================================================= */

  /**
   * Dreht ein Passepartout um 90 Grad. Physisch dasselbe Blatt, nur anders
   * gehaengt: aus zwei Fenstern nebeneinander werden zwei uebereinander, und
   * die Fenster kippen mit. Genau deshalb werden auch Raster und
   * Fenstermasse getauscht und nicht nur das Blattmass.
   */
  function drehePp(pp) {
    return {
      aussen: { b: pp.aussen.h, h: pp.aussen.b },
      anzahl_ausschnitte: pp.anzahl_ausschnitte,
      raster: { spalten: pp.raster.zeilen, zeilen: pp.raster.spalten },
      ausschnitt: { b: pp.ausschnitt.h, h: pp.ausschnitt.b },
      steg: pp.steg,
      rand_lr: pp.rand_ou,
      rand_ou: pp.rand_lr
    };
  }

  /**
   * Rechnet ein Passepartout in die Fenster aus, die es hat.
   *
   * @param {object} pp       Metafeld-Struktur, bereits in der gewuenschten Ausrichtung
   * @returns {{aussenB,aussenH,fenster:Array<{i,spalte,zeile,x,y,b,h}>,ausschnittB,ausschnittH,ratio,randLr,randOu,steg,spalten,zeilen,anzahl}}
   *
   * x/y sind der Versatz von der linken oberen Blattkante in cm. Gefuellt wird
   * in Leserichtung: erst die Zeile nach rechts, dann die naechste Zeile.
   * Dieselbe Reihenfolge nummeriert spaeter die Upload-Slots und den Auftrag.
   */
  function computeGeometry(pp) {
    var spalten = Math.max(1, pp.raster.spalten);
    var zeilen = Math.max(1, pp.raster.zeilen);
    var fenster = [];

    for (var r = 0; r < zeilen; r++) {
      for (var c = 0; c < spalten; c++) {
        fenster.push({
          i: fenster.length,
          spalte: c,
          zeile: r,
          x: pp.rand_lr + c * (pp.ausschnitt.b + pp.steg),
          y: pp.rand_ou + r * (pp.ausschnitt.h + pp.steg),
          b: pp.ausschnitt.b,
          h: pp.ausschnitt.h
        });
      }
    }

    return {
      aussenB: pp.aussen.b,
      aussenH: pp.aussen.h,
      fenster: fenster,
      anzahl: fenster.length,
      spalten: spalten,
      zeilen: zeilen,
      ausschnittB: pp.ausschnitt.b,
      ausschnittH: pp.ausschnitt.h,
      steg: pp.steg,
      randLr: pp.rand_lr,
      randOu: pp.rand_ou,
      /* Alle Fenster sind gleich gross, es gibt also genau ein
         Seitenverhaeltnis fuer alle Zuschnitte. */
      ratio: pp.ausschnitt.b / pp.ausschnitt.h
    };
  }

  /**
   * Passepartout einer Variante, fertig zum Rechnen.
   *
   * Traegt die Variante kein Metafeld, ist es eine Rahmung ohne Passepartout:
   * das Bild fuellt dann das ganze Falzmass. Dessen Masse stehen nur im
   * Groessen-Label der Option ("22,5 X 66,5"), weil es dort nichts zu
   * schneiden gibt und die Werkstatt kein Blatt braucht.
   *
   * @param {object|null} ppRoh    Metafeld-Wert der Variante
   * @param {string} groesseLabel  Optionswert der Groesse, z.B. "24 X 30"
   * @param {boolean|null} wunschQuer  Vom Kunden gewaehlte Lage; null oder
   *   undefined = die natuerliche Lage des Metafeldes
   * @returns {object|null} null, wenn beides fehlt
   *
   * Die Lage wird ABSOLUT uebergeben ("quer") und nicht als Drehung. Die
   * natuerliche Lage ist je Variante verschieden: "24 X 30 / Einfach" ist
   * hoch, "24 X 30 / 2 Ausschnitte" quer. Ein gemerktes Drehflag wuerde beim
   * Wechsel zwischen beiden genau die Lage kippen, die der Kunde eben
   * gewaehlt hat.
   */
  function ppDerVariante(ppRoh, groesseLabel, wunschQuer) {
    var pp = ppRoh ? normalisierePp(ppRoh) : ppOhnePassepartout(groesseLabel);
    if (!pp) return null;
    if (wunschQuer !== true && wunschQuer !== false) return pp;

    var istQuer = pp.aussen.b > pp.aussen.h;
    return istQuer === wunschQuer ? pp : drehePp(pp);
  }

  /** Metafeld-Werte auf Zahlen ziehen; unvollstaendige Saetze werden verworfen. */
  function normalisierePp(roh) {
    if (!roh || !roh.aussen || !roh.ausschnitt || !roh.raster) return null;
    var pp = {
      aussen: { b: zahl(roh.aussen.b), h: zahl(roh.aussen.h) },
      anzahl_ausschnitte: Math.max(1, Math.round(zahl(roh.anzahl_ausschnitte) || 1)),
      raster: {
        spalten: Math.max(1, Math.round(zahl(roh.raster.spalten) || 1)),
        zeilen: Math.max(1, Math.round(zahl(roh.raster.zeilen) || 1))
      },
      ausschnitt: { b: zahl(roh.ausschnitt.b), h: zahl(roh.ausschnitt.h) },
      steg: Math.max(0, zahl(roh.steg) || 0),
      rand_lr: Math.max(0, zahl(roh.rand_lr) || 0),
      rand_ou: Math.max(0, zahl(roh.rand_ou) || 0)
    };
    if (!(pp.aussen.b > 0 && pp.aussen.h > 0 && pp.ausschnitt.b > 0 && pp.ausschnitt.h > 0)) return null;

    /* Die Redundanz im Metafeld ist seine Pruefsumme: Raster mal Fenster plus
       Stege und Raender muss das Blatt ergeben, und das Raster muss zur
       genannten Ausschnittzahl passen. Stimmt das nicht, ist ein Wert
       vertippt — dann lieber die Variante nicht anbieten als Fenster
       zeichnen, die der Schneider nie so schneiden wird. */
    var spalten = pp.raster.spalten, zeilen = pp.raster.zeilen;
    if (spalten * zeilen !== pp.anzahl_ausschnitte) {
      console.error('[SFC] custom.pp_masse: Raster ' + spalten + '×' + zeilen +
        ' passt nicht zu anzahl_ausschnitte ' + pp.anzahl_ausschnitte + '.');
      return null;
    }
    var sollB = 2 * pp.rand_lr + spalten * pp.ausschnitt.b + (spalten - 1) * pp.steg;
    var sollH = 2 * pp.rand_ou + zeilen * pp.ausschnitt.h + (zeilen - 1) * pp.steg;
    if (Math.abs(sollB - pp.aussen.b) > 0.01 || Math.abs(sollH - pp.aussen.h) > 0.01) {
      console.error('[SFC] custom.pp_masse geht nicht auf: gerechnet ' +
        sollB.toFixed(2) + '×' + sollH.toFixed(2) + ' cm, im Metafeld steht ' +
        pp.aussen.b + '×' + pp.aussen.h + ' cm.');
      return null;
    }

    return pp;
  }

  /** Ein randloses Einzelfenster aus dem Groessen-Label, z.B. "13 X 18". */
  function ppOhnePassepartout(groesseLabel) {
    var masse = String(groesseLabel || '')
      .replace(/×/g, 'x')
      .split(/\s*x\s*/i)
      .map(function (teil) { return zahl(teil); })
      .filter(function (n) { return n > 0; });
    if (masse.length < 2) return null;

    return {
      aussen: { b: masse[0], h: masse[1] },
      anzahl_ausschnitte: 1,
      raster: { spalten: 1, zeilen: 1 },
      ausschnitt: { b: masse[0], h: masse[1] },
      steg: 0,
      rand_lr: 0,
      rand_ou: 0
    };
  }

  /** Zahl aus Metafeld oder Label — Komma gilt als Dezimaltrenner. */
  function zahl(wert) {
    if (typeof wert === 'number') return isFinite(wert) ? wert : 0;
    var n = parseFloat(String(wert == null ? '' : wert).replace(',', '.').replace(/[^0-9.\-]/g, ''));
    return isFinite(n) ? n : 0;
  }

  /* =================================================================
   * Firebase-Upload (1:1 dieselbe Mechanik wie frame-configurator.js)
   * ================================================================= */

  var firebaseInitPromise = null;
  var cachedApp = null;
  var cachedAppCheck = null;
  var cachedBucket = null;

  function initFirebase() {
    if (firebaseInitPromise) return firebaseInitPromise;

    firebaseInitPromise = Promise.resolve()
      .then(function () {
        var config = readJson('sfc-firebase-config');
        if (!config || !config.firebase || !config.firebase.apiKey) {
          throw new Error('Firebase-Config fehlt (#sfc-firebase-config)');
        }
        cachedBucket = config.firebase.storageBucket;
        var recaptchaSiteKey = config.recaptcha && config.recaptcha.siteKey;

        if (typeof firebase === 'undefined') {
          throw new Error('Firebase SDK nicht geladen');
        }

        cachedApp = firebase.apps.length ? firebase.apps[0] : firebase.initializeApp(config.firebase);

        if (recaptchaSiteKey && !cachedAppCheck) {
          cachedAppCheck = firebase.appCheck(cachedApp);
          cachedAppCheck.activate(new firebase.appCheck.ReCaptchaV3Provider(recaptchaSiteKey), true);
        }

        return firebase.auth(cachedApp).signInAnonymously();
      })
      .then(function (credential) {
        return Promise.all([
          credential.user.getIdToken(true),
          cachedAppCheck ? cachedAppCheck.getToken(false).then(function (r) { return r.token; }) : Promise.resolve(null)
        ]);
      })
      .then(function (tokens) {
        return { authToken: tokens[0], appCheckToken: tokens[1], bucket: cachedBucket };
      })
      .catch(function (err) {
        firebaseInitPromise = null;
        throw err;
      });

    return firebaseInitPromise;
  }

  function getFreshTokens() {
    var user = cachedApp && firebase.auth(cachedApp).currentUser;
    if (!user) {
      firebaseInitPromise = null;
      return initFirebase();
    }
    return Promise.all([
      user.getIdToken(false),
      cachedAppCheck ? cachedAppCheck.getToken(false).then(function (r) { return r.token; }) : Promise.resolve(null)
    ]).then(function (tokens) {
      return { authToken: tokens[0], appCheckToken: tokens[1], bucket: cachedBucket };
    });
  }

  /**
   * Laedt ein Blob/File nach Firebase Storage und liefert die Download-URL.
   * @param {Blob} blob
   * @param {string} prefix  Dateinamen-Praefix (z.B. 'original' oder 'processed')
   * @param {function(number)=} onProgress  0..100
   */
  function uploadToFirebase(blob, prefix, onProgress) {
    var extension = blob.type === 'image/png' ? 'png' : blob.type === 'image/webp' ? 'webp' : 'jpg';
    var timestamp = new Date().toISOString().replace(/[:.]/g, '-');
    var randomId = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
    var storagePath = 'uploads/' + prefix + '-' + timestamp + '-' + randomId + '.' + extension;

    return initFirebase()
      .then(getFreshTokens)
      .then(function (auth) {
        return new Promise(function (resolve, reject) {
          var url = 'https://firebasestorage.googleapis.com/v0/b/' +
            encodeURIComponent(auth.bucket) + '/o?uploadType=media&name=' +
            encodeURIComponent(storagePath);

          var xhr = new XMLHttpRequest();
          xhr.open('POST', url);
          xhr.setRequestHeader('Authorization', 'Bearer ' + auth.authToken);
          xhr.setRequestHeader('Content-Type', blob.type);
          if (auth.appCheckToken) xhr.setRequestHeader('X-Firebase-AppCheck', auth.appCheckToken);

          xhr.upload.onprogress = function (event) {
            if (onProgress && event.lengthComputable) {
              onProgress(Math.round((event.loaded / event.total) * 100));
            }
          };

          xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 300) {
              try {
                var response = JSON.parse(xhr.responseText);
                var downloadUrl = 'https://firebasestorage.googleapis.com/v0/b/' +
                  encodeURIComponent(auth.bucket) + '/o/' +
                  encodeURIComponent(storagePath) + '?alt=media' +
                  (response.downloadTokens ? '&token=' + response.downloadTokens : '');
                resolve(downloadUrl);
              } catch (e) {
                reject(new Error('Upload-Antwort nicht lesbar'));
              }
            } else {
              reject(new Error('Upload fehlgeschlagen (Status ' + xhr.status + ')'));
            }
          };

          xhr.onerror = function () { reject(new Error('Netzwerkfehler beim Upload')); };
          xhr.send(blob);
        });
      });
  }

  /* =================================================================
   * Hauptlogik
   * ================================================================= */

  /**
   * Normalisiert einen Groessenwert auf einen vergleichbaren Schluessel:
   * "30 X 40", "30x40" und "30 × 40" ergeben alle "30x40".
   * Ohne das haengt die Zuordnung an der Schreibweise im Shopify-Admin.
   *
   * Das Komma bleibt als Punkt erhalten, sonst faelen "22,5 X 66,5" und ein
   * hypothetisches "225 X 665" auf denselben Schluessel.
   */
  function formatSchluessel(wert) {
    return String(wert == null ? '' : wert)
      .toLowerCase()
      .replace(/×/g, 'x')
      .replace(/,/g, '.')
      .replace(/[^0-9x.]/g, '');
  }

  /** Passepartout-Optionswert fuer "gar keins", wie er in Shopify steht. */
  var PP_OHNE = 'Ohne';

  /** Sieht der Optionswert nach einer Groesse aus? ("13 X 18", "22,5 X 66,5") */
  function istGroessenWert(wert) {
    return /^\s*\d+([.,]\d+)?\s*[x×]\s*\d+([.,]\d+)?\s*$/i.test(String(wert == null ? '' : wert));
  }

  /** Sieht der Optionswert nach einer Passepartout-Wahl aus? */
  function istPpWert(wert) {
    var w = String(wert == null ? '' : wert).trim().toLowerCase();
    return w === 'ohne' || w === 'einfach' || /ausschnitt/.test(w);
  }

  /** Zahl der Ausschnitte, die ein Passepartout-Optionswert benennt. */
  function ausschnitteAusWert(wert) {
    var w = String(wert == null ? '' : wert).trim().toLowerCase();
    if (w === 'ohne') return 0;
    var m = w.match(/(\d+)\s*ausschnitt/);
    if (m) return parseInt(m[1], 10);
    return 1;   // "Einfach" und alles andere: ein Fenster
  }

  /**
   * Baut aus den echten Varianten die Matrix Groesse x Passepartout.
   *
   * Bewusst aus den Varianten und nicht aus einer angenommenen Kombinatorik:
   * es gibt laengst nicht jede Paarung. "3 Ausschnitte" existiert nur fuer die
   * beiden Sonderformate, "4 Ausschnitte" nur fuer 40 x 50. Wer die Matrix
   * raet, bietet Varianten an, die niemand bestellen kann.
   *
   * Welche Option die Groesse traegt und welche das Passepartout, wird an der
   * FORM der Werte erkannt, nicht an der Position und nicht am Namen — der
   * Name ist uebersetzbar, die Position je Produkt verschieden.
   */
  function baueMatrix(varianten) {
    var eintraege = [];
    var groessen = [];      // { key, label }
    var ppWerte = [];       // { wert, anzahl }

    (varianten || []).forEach(function (v) {
      var groesse = null;
      var ppWert = null;

      (v.optionen || []).forEach(function (wert) {
        if (groesse === null && istGroessenWert(wert)) groesse = String(wert);
        else if (ppWert === null && istPpWert(wert)) ppWert = String(wert);
      });

      if (groesse === null) return;   // ohne Groesse kein Format — Variante nicht anbieten

      var key = formatSchluessel(groesse);
      if (!groessen.some(function (g) { return g.key === key; })) {
        groessen.push({ key: key, label: groesse });
      }
      if (ppWert !== null && !ppWerte.some(function (p) { return p.wert === ppWert; })) {
        ppWerte.push({ wert: ppWert, anzahl: ausschnitteAusWert(ppWert) });
      }

      eintraege.push({
        v: v,
        groesseKey: key,
        groesseLabel: groesse,
        ppWert: ppWert,
        anzahl: ppWert === null ? 1 : ausschnitteAusWert(ppWert)
      });
    });

    /* Passepartouts nach Ausschnittzahl sortieren: Ohne, 1, 2, 3, 4. Die
       Reihenfolge im Shopify-Admin folgt der Anlagereihenfolge und stand
       zuletzt als Ohne, 1, 2, 3, 4 — verlassen wollen wir uns darauf nicht. */
    ppWerte.sort(function (a, b) { return a.anzahl - b.anzahl; });

    /* Groessen nach Flaeche: die Kacheln stehen dann von klein nach gross,
       unabhaengig davon, in welcher Reihenfolge die Varianten angelegt wurden. */
    groessen.sort(function (a, b) {
      return flaecheAusLabel(a.label) - flaecheAusLabel(b.label);
    });

    return { eintraege: eintraege, groessen: groessen, ppWerte: ppWerte };
  }

  function flaecheAusLabel(label) {
    var teile = String(label).replace(/×/g, 'x').split(/\s*x\s*/i);
    return (zahl(teile[0]) || 0) * (zahl(teile[1]) || 0);
  }

  function init() {
    var root = $('standard-frame-configurator');
    if (!root) return;

    /* Sticky-Offset der Vorschau. Die Hoehe wird hier gemessen und lokal auf
       der Section gesetzt, statt --fc-header-height des grossen Konfigurators
       mitzubenutzen: dessen JS laeuft auf Standardformat-Seiten nie, weshalb
       dort dauerhaft der 68px-Fallback griff. Der Header ist real hoeher. */
    function applyHeaderHeight() {
      var header = document.querySelector('sticky-header') ||
                   document.querySelector('.header-wrapper');
      if (!header) return;
      var h = header.offsetHeight;
      if (h > 0) root.style.setProperty('--sfc-header-height', h + 'px');
    }
    applyHeaderHeight();

    var productData = readJson('sfc-product-data');
    var formatConfig = readJson('sfc-format-config');
    if (!productData || !formatConfig) {
      console.error('[SFC] Konfiguration unvollstaendig — Konfigurator wird nicht gestartet.');
      return;
    }

    // Theme-Editor-Felder sind Freitext: ein deutschsprachig eingetipptes "5,5" darf
    // die Geometrie nicht stillschweigend auf 5 zusammenfallen lassen.
    function toNumber(value, fallback) {
      var parsed = parseFloat(String(value == null ? '' : value).replace(',', '.'));
      return isFinite(parsed) && parsed >= 0 ? parsed : fallback;
    }

    var beispiele = readJson('sfc-beispiele-daten') || [];
    var texte = readJson('sfc-texte') || {};
    var leisten = readJson('sfc-leisten-daten') || [];
    var varianten = productData.variants || [];

    /* Die Matrix aus Groesse x Passepartout, gebaut aus den echten Varianten.
       Sie ist die einzige Quelle dafuer, was waehlbar ist. */
    var matrix = baueMatrix(varianten);
    var ppOptionVorhanden = matrix.ppWerte.length > 1;

    /* Varianten MIT Passepartout, aber OHNE gepflegtes Metafeld, werden nicht
       angeboten: ihre Schnittmasse sind unbekannt, und ein aus dem Label
       geratenes Passepartout waere eine erfundene Produktionsangabe. Lieber
       eine Option weniger als eine falsch geschnittene Bestellung. */
    var ungepflegt = matrix.eintraege.filter(function (e) {
      return e.ppWert !== null && e.ppWert !== PP_OHNE && !e.v.pp;
    });
    if (ungepflegt.length) {
      console.warn('[SFC] ' + ungepflegt.length + ' Variante(n) mit Passepartout ohne Metafeld ' +
        'custom.pp_masse — sie werden nicht angeboten:',
        ungepflegt.map(function (e) { return e.groesseLabel + ' / ' + e.ppWert; }));
      matrix.eintraege = matrix.eintraege.filter(function (e) {
        return ungepflegt.indexOf(e) === -1;
      });
    }

    /* Startvariante: was in der URL steht, sonst die vom Server gelieferte. */
    var startVariante = null;
    for (var vi = 0; vi < varianten.length; vi++) {
      if (String(varianten[vi].id) === String(productData.variantId)) startVariante = varianten[vi];
    }
    if (!startVariante && varianten.length) startVariante = varianten[0];

    /* Das Passepartout der aktuellen Wahl, in der aktuellen Ausrichtung.
       Einzige Geometriequelle fuer Vorschau, Zuschnitt, Masse und Auftrag. */
    var geo = null;

    function eintragVon(groesseKey, ppWert) {
      for (var i = 0; i < matrix.eintraege.length; i++) {
        var e = matrix.eintraege[i];
        if (e.groesseKey !== groesseKey) continue;
        if (ppWert === null || ppWert === undefined) return e;
        /* Ein Eintrag ohne erkannten Passepartout-Wert ist KEIN Treffer fuer
           jede Anfrage: sonst taucht eine Variante mit einem unbekannten
           Optionswert ("Galerie 2x2") unter jeder Ausschnittzahl auf und
           liefert dort falsche Preise und Masse. */
        if (e.ppWert === ppWert) return e;
      }
      return null;
    }

    /** Groessen, die es zur gewaehlten Ausschnittzahl gibt — in Flaechenfolge. */
    function groessenFuer(ppWert) {
      return matrix.groessen.filter(function (g) {
        return !!eintragVon(g.key, ppWert);
      });
    }

    /**
     * Rechnet die Geometrie der aktuellen Wahl neu.
     * Faellt still auf den ersten gueltigen Eintrag zurueck, statt mit einer
     * kaputten Vorschau weiterzulaufen.
     */
    function uebernehmeFormat() {
      var eintrag = eintragVon(state.groesseKey, ppOptionVorhanden ? state.pp : null);
      if (!eintrag) eintrag = matrix.eintraege[0] || null;
      if (!eintrag) { geo = null; return; }

      state.groesseKey = eintrag.groesseKey;
      if (eintrag.ppWert !== null) state.pp = eintrag.ppWert;

      var pp = ppDerVariante(eintrag.v.pp, eintrag.groesseLabel, state.wunschQuer);
      if (!pp) {
        console.error('[SFC] Passepartout-Masse unbrauchbar fuer',
          eintrag.groesseLabel, '/', eintrag.ppWert, '— Variante wird uebersprungen.');
        geo = null;
        return;
      }
      geo = computeGeometry(pp);
    }

    /**
     * Ein leerer Bild-Slot. Es gibt einen je Passepartout-Ausschnitt; ohne
     * Passepartout genau einen.
     *
     * Jeder Slot traegt seinen eigenen cropToken: ein gemeinsamer Zaehler
     * wuerde bei vier parallel laufenden Zuschnitten alle bis auf den zuletzt
     * gestarteten stillschweigend verwerfen — drei Bilder kaemen dann
     * unzugeschnitten in die Bestellung.
     */
    function leererSlot() {
      return {
        /** Originalbild — bleibt immer erhalten, damit Crop nicht destruktiv ist. */
        original: null,        // { blobUrl, width, height, type, name }
        originalRemoteUrl: null,
        originalUploadPromise: null,

        /** Ausschnitt in Pixeln des Originalbildes. */
        crop: null,            // { x, y, w, h }
        croppedBlob: null,
        croppedBlobUrl: null,
        croppedRemoteUrl: null,
        croppedDirty: true,    // true = croppedRemoteUrl passt nicht mehr zum aktuellen Crop

        cropToken: 0,
        cropPromise: null,

        /** DOM des Slots, von renderSlots gesetzt. */
        el: null
      };
    }

    var state = {
      /** Vom Kunden gewaehlte Lage: true = quer, false = hoch, null = die
          natuerliche des Metafeldes. Absolut gespeichert und nicht als
          Drehung — siehe ppDerVariante. */
      wunschQuer: null,
      orientationInitialised: false,
      orientationTouchedByUser: false,
      matColor: SFC_MAT_COLORS[0].color,

      /** true, sobald der Kunde eine Aufloesungswarnung weggeklickt hat.
          Geht als _aufloesung_ok an die Werkstatt. */
      aufloesungBestaetigt: false,

      /** Gewaehlte Leiste und Filter des Wechslers. */
      leisteHandle: null,
      leisteFilter: 'Alle',

      /** Gewaehlte Groesse und Passepartout. Beide bestimmen zusammen die
          Shopify-Variante und damit den Preis. */
      groesseKey: null,
      pp: null,

      /** Beispielbild: gesetzt, solange der Kunde noch kein eigenes Bild hat.
          Es gibt damit keinen leeren Ausgangszustand mehr — die Seite zeigt
          beim Laden eine vollstaendige Rahmung. */
      beispielIndex: 0,

      /** Ein Slot je Ausschnitt, in Leserichtung. */
      slots: [leererSlot()],

      /** Slot, dessen Bild der Zuschnitt-Dialog gerade bearbeitet. */
      aktiverSlot: 0
    };

    /** Kurzform fuer den Slot, der gerade im Zuschnitt-Dialog liegt. */
    function slot(i) {
      return state.slots[i == null ? state.aktiverSlot : i] || state.slots[0];
    }

    /** Hat mindestens ein Slot ein Bild? */
    function hatBild() {
      return state.slots.some(function (s) { return !!s.original; });
    }

    /** Haben ALLE Slots ein Bild? Erst dann ist die Rahmung vollstaendig. */
    function alleBilderDa() {
      return state.slots.every(function (s) { return !!s.original; });
    }

    /** Index des ersten Slots ohne Bild, sonst -1. */
    function ersterLeererSlot() {
      for (var i = 0; i < state.slots.length; i++) {
        if (!state.slots[i].original) return i;
      }
      return -1;
    }

    /* ---------------- DOM ---------------- */
    var els = {
      preview: $('sfc-preview'),
      beispielHinweis: $('sfc-beispiel-hinweis'),
      leisteChips: $('sfc-leiste-chips'),
      leisten: $('sfc-leisten'),
      leisteValue: $('sfc-leiste-value'),
      leisteLeer: $('sfc-leiste-leer'),
      titel: root.querySelector('.sfc__title'),
      formatKacheln: $('sfc-format-kacheln'),
      formatValue: $('sfc-format-value'),
      ppWahl: $('sfc-pp-wahl'),
      matFarbeBlock: $('sfc-mat-farbe-block'),
      ppMotivsatz: $('sfc-pp-motivsatz'),
      ppErklaerung: $('sfc-pp-erklaerung'),
      footer: $('sfc-footer'),
      mobilbar: $('sfc-mobilbar'),
      mobilbarFormat: $('sfc-mobilbar-format'),
      mobilbarPreis: $('sfc-mobilbar-preis'),
      mobilbarKnopf: $('sfc-mobilbar-knopf'),
      beispiele: $('sfc-beispiele'),
      slider: $('sfc-slider'),
      punkte: $('sfc-punkte'),
      galerieZurueck: $('sfc-galerie-zurueck'),
      galerieWeiter: $('sfc-galerie-weiter'),
      formatLabel: $('sfc-format-label'),

      fileInput: $('sfc-file'),
      uploads: $('sfc-uploads'),
      slotVorlage: $('sfc-slot-vorlage'),
      uploadError: $('sfc-upload-error'),
      uploadQuality: $('sfc-upload-quality'),

      orientationOptions: $('sfc-orientation-options'),
      orientationValue: $('sfc-orientation-value'),
      orientationAuto: $('sfc-orientation-auto'),

      matColors: $('sfc-mat-colors'),
      matValue: $('sfc-mat-value'),

      price: $('sfc-price'),
      priceTop: $('sfc-price-top'),
      footerDetail: $('sfc-footer-detail'),
      delivery: $('sfc-delivery'),
      atc: $('sfc-add-to-cart'),
      atcText: $('sfc-atc-text'),
      atcSub: $('sfc-atc-sub'),
      atcLoading: $('sfc-atc-loading'),
      atcError: $('sfc-atc-error'),

      crop: $('sfc-crop'),
      cropBackdrop: $('sfc-crop-backdrop'),
      cropStage: $('sfc-crop-stage'),
      cropImgWrap: $('sfc-crop-imgwrap'),
      cropImg: $('sfc-crop-img'),
      cropShade: $('sfc-crop-shade'),
      cropBox: $('sfc-crop-box'),
      cropRatio: $('sfc-crop-ratio'),
      cropWarn: $('sfc-crop-warn'),
      cropClose: $('sfc-crop-close'),
      cropCancel: $('sfc-crop-cancel'),
      cropReset: $('sfc-crop-reset'),
      cropConfirm: $('sfc-crop-confirm')
    };

    /* ---------------- Geometrie ---------------- */

    function geometry() {
      return geo;
    }

    /**
     * Eine Wahrheit fuer "ohne Passepartout" — fuer Vorschau, Masse UND
     * Warenkorb.
     *
     * Bewusst nicht ueber ppOptionVorhanden: das Flag sagt nur, ob es etwas zu
     * WAEHLEN gibt. Eine Leiste, die nur ohne Passepartout verkauft wird, hat
     * genau einen Optionswert — und bekaeme sonst im Warenkorb eine
     * Passepartout-Farbe und Randmasse, nach denen die Werkstatt ein Blatt
     * schneiden wuerde, das es gar nicht gibt.
     */
    function istOhnePp(g) {
      if (state.pp === PP_OHNE) return true;
      var pruefe = g || geo;
      return !pruefe || (pruefe.randLr === 0 && pruefe.randOu === 0 && pruefe.anzahl === 1);
    }

    /* ---------------- Bild-Slots ----------------
     * Die Zahl der Slots folgt der Zahl der Ausschnitte. Sie aendert sich,
     * sobald der Kunde das Passepartout wechselt — deshalb werden die Slots
     * nicht im Markup vorgehalten, sondern hier aus der Vorlage gebaut.
     */

    /**
     * Bringt state.slots auf die verlangte Zahl.
     *
     * Vorhandene Bilder bleiben, wo sie sind: wer von zwei auf vier Ausschnitte
     * wechselt, behaelt seine beiden Bilder und ergaenzt zwei. Beim Verkleinern
     * werden die ueberzaehligen Slots samt ihrer Blob-URLs freigegeben.
     *
     * @returns {boolean} true, wenn sich die Zahl geaendert hat
     */
    function setzeSlotZahl(anzahl) {
      anzahl = Math.max(1, anzahl || 1);
      if (state.slots.length === anzahl) return false;

      /* Ein offener Zuschnitt haengt an einem Slot, den es gleich nicht mehr
         gibt — und an dessen Bildmassen in cropUi. Bliebe er offen, schriebe
         "Uebernehmen" ein Rechteck, das fuer ein anderes Bild gezogen wurde,
         in Slot 0 und erzeugte daraus sofort das Druckfile. */
      if (els.crop && !els.crop.hidden) closeCropEditor();

      while (state.slots.length > anzahl) {
        var weg = state.slots.pop();
        /* Laufenden Zuschnitt entwerten: sein toBlob-Callback haelt das
           Slot-Objekt fest und wuerde sonst noch eine Blob-URL anlegen,
           die niemand mehr freigibt. */
        weg.cropToken++;
        gibSlotFrei(weg);
      }
      while (state.slots.length < anzahl) {
        state.slots.push(leererSlot());
      }
      if (state.aktiverSlot >= anzahl) state.aktiverSlot = 0;

      /* Mehrfachauswahl nur dort erlauben, wo sie etwas nuetzt. Bei einem
         Ausschnitt — dem haeufigsten Fall — bliebe eine zweite gewaehlte Datei
         sonst stumm liegen. Am Handy ist der Dateidialog der einzige Weg, es
         gibt dort kein Ziehen und Ablegen. */
      if (els.fileInput) {
        if (anzahl > 1) els.fileInput.setAttribute('multiple', '');
        else els.fileInput.removeAttribute('multiple');
      }
      return true;
    }

    /** Blob-URLs eines Slots freigeben — sonst haelt der Browser die Bilder fest. */
    function gibSlotFrei(s) {
      if (!s) return;
      if (s.original && s.original.blobUrl) URL.revokeObjectURL(s.original.blobUrl);
      if (s.croppedBlobUrl) URL.revokeObjectURL(s.croppedBlobUrl);
    }

    /**
     * Ein kleines Raster, das zeigt, wo dieser Ausschnitt im Passepartout
     * sitzt. Zwei Zeilen Code statt einer Erklaerung: bei vier Fenstern muss
     * man sehen koennen, welches Bild oben links landet.
     */
    function lagePiktogramm(index) {
      if (!geo || geo.anzahl < 2) return '';

      /* Massstaeblich, nicht ins Quadrat gezwaengt: bei einem 66,5 x 22,5 cm
         langen Dreifach-Blatt saehe ein quadratisches Raster aus wie drei
         hohe Fenster — also das Gegenteil dessen, was der Kunde bekommt. */
      var hoehe = 18;
      var skala = hoehe / Math.max(geo.aussenB, geo.aussenH);
      var b = geo.aussenB * skala;
      var h = geo.aussenH * skala;

      var zellen = '';
      geo.fenster.forEach(function (f, i) {
        zellen += '<rect x="' + (f.x * skala) + '" y="' + (f.y * skala) +
          '" width="' + (f.b * skala) + '" height="' + (f.h * skala) +
          '" fill="' + (i === index ? 'currentColor' : 'none') +
          '" stroke="currentColor" stroke-width="0.7" opacity="' + (i === index ? '1' : '0.4') + '"/>';
      });

      return '<svg viewBox="0 0 ' + b + ' ' + h + '" width="' + b + '" height="' + h +
        '" aria-hidden="true">' +
        '<rect x="0" y="0" width="' + b + '" height="' + h +
        '" fill="none" stroke="currentColor" stroke-width="0.7" opacity="0.5"/>' +
        zellen + '</svg>';
    }

    /**
     * Baut die Ablagen neu. Wird nur gerufen, wenn sich die Zahl der Slots
     * oder das Raster aendert — nicht bei jedem Bildwechsel, dafuer gibt es
     * zeigeSlot().
     */
    function renderSlots() {
      if (!els.uploads || !els.slotVorlage) return;
      els.uploads.innerHTML = '';
      var mehrere = state.slots.length > 1;
      els.uploads.classList.toggle('sfc-uploads--raster', mehrere);

      /* Die Ablagen stehen wie die Fenster im Passepartout: drei nebeneinander
         bei einem 3x1-Raster, zwei mal zwei bei einem 2x2. Damit stimmt die
         Anordnung auf dem Bildschirm mit der im Rahmen ueberein, und man muss
         die Zuordnung nicht aus den Nummern erschliessen. Auf dem Handy
         deckelt das CSS auf zwei Spalten, sonst wird jede Ablage zu schmal. */
      if (mehrere) els.uploads.style.setProperty('--sfc-slot-spalten', String(geo ? geo.spalten : 1));
      else els.uploads.style.removeProperty('--sfc-slot-spalten');

      state.slots.forEach(function (s, i) {
        var knoten = els.slotVorlage.content.firstElementChild.cloneNode(true);
        knoten.dataset.slot = String(i);
        s.el = knoten;

        var kopf = rolle(knoten, 'kopf');
        if (kopf) {
          kopf.hidden = !mehrere;
          if (mehrere) {
            var nummer = rolle(knoten, 'nummer');
            if (nummer) nummer.textContent = String(i + 1);
            var lage = rolle(knoten, 'lage');
            if (lage) lage.innerHTML = lagePiktogramm(i);
          }
        }

        els.uploads.appendChild(knoten);
        zeigeSlot(i);
      });
    }

    /** Element mit der gegebenen Rolle innerhalb eines Slots. */
    function rolle(wurzel, name) {
      return wurzel ? wurzel.querySelector('[data-rolle="' + name + '"]') : null;
    }

    /** Spiegelt den Zustand eines Slots in seine Ablage. */
    function zeigeSlot(i) {
      var s = state.slots[i];
      if (!s || !s.el) return;
      var hat = !!s.original;

      var prompt = rolle(s.el, 'prompt');
      var done = rolle(s.el, 'done');
      if (prompt) prompt.hidden = hat;
      if (done) done.hidden = !hat;

      var thumb = rolle(s.el, 'thumb');
      if (thumb && hat) {
        var quelle = s.croppedBlobUrl || s.original.blobUrl;
        if (thumb.src !== quelle) thumb.src = quelle;
        thumb.alt = state.slots.length > 1 ? ('Dein Bild fuer Ausschnitt ' + (i + 1)) : 'Dein Bild';
      }

      s.el.classList.toggle('sfc-upload--gefuellt', hat);
    }

    /**
     * Fortschrittsbalken EINES Slots.
     *
     * @param {object} [erwartet] Slot-Objekt, zu dem der Fortschritt gehoert.
     *   Ein laufender Upload haelt sein Slot-Objekt fest, der Balken haengt
     *   aber am Index: nach einem Wechsel der Ausschnittzahl liegt dort ein
     *   anderer, leerer Slot, dessen Balken sich sonst von einem laengst
     *   verworfenen Bild bewegen liesse.
     */
    function setzeSlotFortschritt(i, prozent, erwartet) {
      var s = state.slots[i];
      if (!s || !s.el) return;
      if (erwartet && s !== erwartet) return;
      var fortschritt = rolle(s.el, 'progress');
      var balken = rolle(s.el, 'bar');
      var pct = rolle(s.el, 'pct');
      if (prozent === null) {
        if (fortschritt) fortschritt.hidden = true;
        return;
      }
      var wert = clamp(Math.round(prozent), 0, 100);
      if (fortschritt) fortschritt.hidden = false;
      if (balken) balken.style.width = wert + '%';
      if (pct) pct.textContent = wert + ' %';
    }

    /* ---------------- Akkordeon ----------------
     * Gleiches Verhalten wie im grossen Konfigurator: es ist immer genau ein
     * Schritt offen, der Untertitel zeigt den aktuellen Wert des Schrittes.
     */

    var tabLeiste = $('sfc-tabs');

    function openStep(step) {
      if (!step) return;
      var all = root.querySelectorAll('.sfc-step');
      for (var i = 0; i < all.length; i++) {
        var isTarget = all[i] === step;
        all[i].classList.toggle('sfc-step--open', isTarget);
        var header = all[i].querySelector('.sfc-step__header');
        if (header) header.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
      }
      syncTabs();
    }

    function bindAccordion() {
      var headers = root.querySelectorAll('.sfc-step__header');
      for (var i = 0; i < headers.length; i++) {
        headers[i].addEventListener('click', function (event) {
          var step = event.currentTarget.closest('.sfc-step');
          if (step.classList.contains('sfc-step--open')) {
            step.classList.remove('sfc-step--open');
            event.currentTarget.setAttribute('aria-expanded', 'false');
          } else {
            openStep(step);
          }
          syncTabs();
        });
      }
    }

    /* ---------------- Schrittleiste (Handy) ----------------
     * Auf dem Handy sind die Kopfzeilen ausgeblendet, die Leiste navigiert
     * an ihrer Stelle — von links nach rechts statt von oben nach unten.
     * Sie schaltet denselben Zustand wie eine Kopfzeile, es bleibt also bei
     * genau einem offenen Schritt. Dieselbe Mechanik wie .fc-mobile-tabs im
     * grossen Konfigurator.
     */

    /** Setzt den aktiven Knopf und schiebt ihn waagerecht ins Bild. */
    function syncTabs() {
      if (!tabLeiste) return;
      var offen = root.querySelector('.sfc-step.sfc-step--open');
      var offenId = offen ? offen.getAttribute('data-step-id') : null;
      var knoepfe = tabLeiste.querySelectorAll('[data-tab-target]');
      for (var i = 0; i < knoepfe.length; i++) {
        var knopf = knoepfe[i];
        var aktiv = knopf.getAttribute('data-tab-target') === offenId;
        knopf.classList.toggle('sfc-tabs__btn--aktiv', aktiv);
        knopf.setAttribute('aria-selected', aktiv ? 'true' : 'false');
        /* Bewusst ueber scrollLeft und nicht ueber scrollIntoView: letzteres
           wuerde auch die Seite senkrecht verschieben, hier soll sich nur
           die Leiste bewegen. */
        if (aktiv && !knopf.hidden) {
          var ziel = knopf.offsetLeft - (tabLeiste.clientWidth - knopf.offsetWidth) / 2;
          tabLeiste.scrollLeft = Math.max(0, ziel);
        }
      }
    }

    /** Ein Schritt, den es nicht gibt oder den die Datenlage ausblendet,
        nimmt seinen Knopf mit. */
    /**
     * Vergibt die Schrittnummern nach der sichtbaren Reihenfolge. Welche
     * Schritte es gibt, haengt an Einstellungen und Datenlage und kann sich
     * mitten im Ablauf aendern — etwa wenn eine Ausschnittzahl nur ein Format
     * hat und der Format-Schritt entfaellt.
     */
    function nummeriereSchritte() {
      var alle = root.querySelectorAll('.sfc-step');
      var n = 0;
      for (var i = 0; i < alle.length; i++) {
        if (alle[i].hidden) continue;
        n++;
        var num = alle[i].querySelector('.sfc-step__num');
        if (num) num.textContent = String(n);
      }
    }

    function syncTabSichtbarkeit() {
      if (!tabLeiste) return;
      var knoepfe = tabLeiste.querySelectorAll('[data-tab-target]');
      for (var i = 0; i < knoepfe.length; i++) {
        var step = root.querySelector('.sfc-step[data-step-id="' + knoepfe[i].getAttribute('data-tab-target') + '"]');
        knoepfe[i].hidden = !step || step.hidden;
      }
    }

    function bindTabs() {
      if (!tabLeiste) return;
      tabLeiste.addEventListener('click', function (event) {
        var knopf = event.target.closest('[data-tab-target]');
        if (!knopf) return;
        var step = root.querySelector('.sfc-step[data-step-id="' + knopf.getAttribute('data-tab-target') + '"]');
        // Knoepfe klappen nicht zu: ein Tippen auf den aktiven Schritt laesst ihn offen.
        if (step) openStep(step);
      });
    }

    /** Haelt die Untertitel der Step-Kopfzeilen aktuell. */
    function updateStepSubtitles() {
      var g = geometry();
      var masse = g ? (formatCm(g.aussenB) + ' × ' + formatCm(g.aussenH) + ' cm') : '–';

      if (els.formatValue) els.formatValue.textContent = masse;
      if (els.formatLabel) els.formatLabel.textContent = masse;

      if (els.matValue && ppOptionVorhanden) {
        if (state.pp === PP_OHNE) {
          els.matValue.textContent = 'Ohne Passepartout';
        } else {
          var farbe = mattFarben().filter(function (c) { return c.color === state.matColor; })[0];
          var name = farbe ? farbe.displayName : '';
          els.matValue.textContent = g && g.anzahl > 1
            ? (g.anzahl + ' Ausschnitte' + (name ? ' · ' + name : ''))
            : (name || 'Mit Passepartout');
        }
      }

      /* Der Untertitel zaehlt mit, solange noch Ablagen leer sind — so steht
         schon in der zugeklappten Kopfzeile, was noch fehlt. */
      var subUpload = $('sfc-sub-upload');
      var gefuellt = state.slots.filter(function (x) { return !!x.original; }).length;
      if (subUpload) {
        if (state.slots.length > 1) {
          subUpload.textContent = gefuellt + ' von ' + state.slots.length + ' Bildern gewählt';
        } else {
          subUpload.textContent = gefuellt ? 'Bild ausgewählt' : 'Noch kein Bild gewählt';
        }
      }
      var stepUpload = $('sfc-step-upload');
      if (stepUpload) stepUpload.classList.toggle('sfc-step--done', alleBilderDa());

      /* Ueberschrift und Schrittleiste ziehen mit: bei mehreren Ausschnitten
         heisst der Schritt "Deine Bilder". Der eingestellte Text bleibt als
         Ausgangswert erhalten, damit der Wechsel zurueck auf einen Ausschnitt
         ihn nicht verliert. */
      var titel = stepUpload ? stepUpload.querySelector('.sfc-step__title') : null;
      var tabLabel = tabLeiste ? tabLeiste.querySelector('[data-tab-target="upload"] .sfc-tabs__label') : null;
      [titel, tabLabel].forEach(function (el) {
        if (!el) return;
        if (!el.dataset.standard) el.dataset.standard = el.textContent;
        el.textContent = state.slots.length > 1 ? 'Deine Bilder' : el.dataset.standard;
      });
    }

    /* ---------------- Vorschau ---------------- */

    /* =================================================================
     * Zustand ueber Leistenwechsel und Neuladen hinweg
     * ================================================================= */

    var SPEICHER_KEY = 'sfc-zustand';

    /**
     * Sichert die Wahl in der Session. Bewusst nur Firebase-URLs, keine
     * blob:-Adressen — die gelten nur fuer das laufende Dokument und waeren
     * nach einem Neuladen tote Verweise.
     */
    function sichereZustand() {
      try {
        window.sessionStorage.setItem(SPEICHER_KEY, JSON.stringify({
          leiste: state.leisteHandle,
          groesse: state.groesseKey,
          pp: state.pp,
          quer: state.wunschQuer,
          orientationTouched: state.orientationTouchedByUser,
          matColor: state.matColor,
          beispielIndex: state.beispielIndex,
          /* Ein Eintrag je Ausschnitt. Die Reihenfolge ist die Zuordnung —
             Eintrag 0 gehoert zu Ausschnitt 0. */
          slots: state.slots.map(function (x) {
            return { bildUrl: x.originalRemoteUrl || null, crop: x.crop || null };
          }),
          gespeichertAm: Date.now()
        }));
      } catch (e) { /* privater Modus o.ae. — der Konfigurator laeuft weiter */ }
    }

    function leseZustand() {
      try {
        var roh = window.sessionStorage.getItem(SPEICHER_KEY);
        if (!roh) return null;
        var z = JSON.parse(roh);
        // Aelter als der Sessionbegriff des Kunden: lieber frisch anfangen.
        if (!z || (Date.now() - (z.gespeichertAm || 0)) > 12 * 3600 * 1000) return null;
        return z;
      } catch (e) { return null; }
    }

    /**
     * Holt ein zuvor hochgeladenes Bild nach einem Neuladen zurueck. Schlaegt
     * das fehl — abgelaufener Firebase-Token, kein Netz —, bleibt es beim
     * Beispielzustand statt bei einer kaputten Vorschau.
     */
    function stelleBildWiederHer(z) {
      if (!z) return;

      /* Aeltere Sitzungen haben ein einzelnes Bild gespeichert. Das gilt als
         Ausschnitt 1 — sonst verliert jeder, der die Seite gerade offen hat,
         beim naechsten Laden sein Bild. */
      var eintraege = z.slots || (z.bildUrl ? [{ bildUrl: z.bildUrl, crop: z.crop || null }] : []);
      if (!eintraege.length) return;

      var offen = 0;
      var fertig = [];

      eintraege.forEach(function (eintrag, i) {
        if (!eintrag || !eintrag.bildUrl || i >= state.slots.length) return;
        offen++;
        var bild = new Image();
        bild.crossOrigin = 'anonymous';

        bild.onload = function () {
          var s = state.slots[i];
          s.original = {
            blobUrl: eintrag.bildUrl, width: bild.naturalWidth, height: bild.naturalHeight, type: 'image/jpeg'
          };
          s.originalRemoteUrl = eintrag.bildUrl;
          s.crop = eintrag.crop ||
            maxCenteredCrop(bild.naturalWidth, bild.naturalHeight, geo ? geo.ratio : 1);
          zeigeSlot(i);
          fertig.push(i);
          if (--offen === 0) abschliessen();
        };

        bild.onerror = function () {
          console.warn('[SFC] Gespeichertes Bild ' + (i + 1) + ' nicht mehr erreichbar — Ausschnitt bleibt leer.');
          if (--offen === 0) abschliessen();
        };

        bild.src = eintrag.bildUrl;
      });

      /* Die Zuschnitte laufen erst, wenn alle Bilder da sind — sonst rendert
         die Vorschau einmal je Bild neu. */
      function abschliessen() {
        if (!fertig.length) return;
        applyAlleCrops(fertig).then(function () {
          updateStepSubtitles();
          markiereBeispielAuswahl();
          updateSummary();
        });
      }
    }

    /* =================================================================
     * Leistenwechsler
     * ================================================================= */

    /** Reihenfolge der Filter-Chips, nach Beliebtheit statt alphabetisch. */
    var CHIP_REIHENFOLGE = (texte.chipReihenfolge || 'Holz,Schwarz,Weiß,Gold,Silber,Bunt')
      .split(',').map(function (x) { return x.trim(); }).filter(Boolean);

    /** Wie viele der ersten Leisten der Kollektion den Hinweis "Beliebt" tragen. */
    var BELIEBT_BIS = typeof texte.beliebtBis === 'number' ? texte.beliebtBis : 3;

    function leisteNachHandle(handle) {
      for (var i = 0; i < leisten.length; i++) {
        if (leisten[i].handle === handle) return leisten[i];
      }
      return null;
    }

    /** Preis einer Leiste bei der aktuellen Groessen- und Passepartout-Wahl. */
    function leistenPreis(leiste) {
      var fremd = baueMatrix(leiste.varianten || []);
      for (var i = 0; i < fremd.eintraege.length; i++) {
        var e = fremd.eintraege[i];
        if (e.groesseKey !== state.groesseKey) continue;
        if (!ppOptionVorhanden || e.ppWert === null || e.ppWert === state.pp) {
          return typeof e.v.preis === 'number' ? e.v.preis : null;
        }
      }
      return null;
    }

    function renderChips() {
      if (!els.leisteChips) return;
      var vorhandene = {};
      leisten.forEach(function (l) { if (l.farbe) vorhandene[l.farbe] = true; });

      var chips = ['Alle'].concat(CHIP_REIHENFOLGE.filter(function (f) { return vorhandene[f]; }));
      els.leisteChips.innerHTML = '';
      chips.forEach(function (name) {
        var aktiv = state.leisteFilter === name;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sfc-chip' + (aktiv ? ' sfc-chip--aktiv' : '');
        b.setAttribute('data-chip', name);
        b.setAttribute('aria-pressed', aktiv ? 'true' : 'false');
        b.textContent = name;
        els.leisteChips.appendChild(b);
      });
    }

    function renderLeisten() {
      if (!els.leisten) return;
      els.leisten.innerHTML = '';

      var eigenerPreis = leistenPreis(aktuelleLeiste()) ;
      var sichtbar = leisten.filter(function (l) {
        return state.leisteFilter === 'Alle' || l.farbe === state.leisteFilter;
      });

      if (els.leisteLeer) els.leisteLeer.hidden = sichtbar.length > 0;

      sichtbar.forEach(function (l) {
        var gewaehlt = l.handle === state.leisteHandle;
        var preis = leistenPreis(l);

        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sfc-leiste' + (gewaehlt ? ' sfc-leiste--aktiv' : '');
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', gewaehlt ? 'true' : 'false');
        b.setAttribute('data-leiste', l.handle);

        if (l.eckbild) {
          var img = document.createElement('img');
          img.className = 'sfc-leiste__bild';
          img.src = l.eckbild;
          img.loading = 'lazy';
          img.alt = l.titel;
          b.appendChild(img);
        }

        var name = document.createElement('span');
        name.className = 'sfc-leiste__name';
        name.textContent = l.titel;
        b.appendChild(name);

        var masse = document.createElement('span');
        masse.className = 'sfc-leiste__masse';
        masse.textContent = l.hoeheMM + ' × ' + l.breiteMM + ' mm';
        b.appendChild(masse);

        /* Preisdifferenz zur aktuell gewaehlten Leiste. Von vierzehn geprueften
           Wettbewerbern macht das genau einer — deshalb steht sie an jeder Ecke
           und nicht nur beim Wechsel. */
        if (preis !== null && eigenerPreis !== null) {
          var diff = preis - eigenerPreis;
          var d = document.createElement('span');
          d.className = 'sfc-leiste__diff' + (diff === 0 ? ' sfc-leiste__diff--gleich' : '');
          d.textContent = diff === 0 ? '±0' :
            (diff > 0 ? '+' : '−') + formatMoney(Math.abs(diff));
          b.appendChild(d);
        }

        if (l.rang < BELIEBT_BIS) {
          var hinweis = document.createElement('span');
          hinweis.className = 'sfc-leiste__beliebt';
          hinweis.textContent = texte.beliebtLabel || 'Beliebt';
          b.appendChild(hinweis);
        }

        els.leisten.appendChild(b);
      });
    }

    function aktuelleLeiste() {
      return leisteNachHandle(state.leisteHandle) || {
        handle: productData.handle, titel: productData.title,
        breiteMM: productData.frameBreiteMM, hoeheMM: productData.frameHoeheMM,
        texturLR: productData.frameImageLR, texturTB: productData.frameImageTB,
        varianten: varianten, rang: -1
      };
    }

    /**
     * Wechselt die Leiste, ohne die Seite neu zu laden. Bild, Zuschnitt,
     * Format, Ausrichtung und Passepartout bleiben unangetastet — es aendern
     * sich nur Texturen, Masse, Varianten und die Adresse.
     */
    function wechsleLeiste(handle, inUrl) {
      var l = leisteNachHandle(handle);
      if (!l || handle === state.leisteHandle) return;

      state.leisteHandle = handle;

      // Der Konfigurator liest Textur und Masse aus productData — also dort
      // nachziehen, statt jede Lesestelle umzubauen.
      productData.handle = l.handle;
      productData.title = l.titel;
      productData.frameImageLR = l.texturLR;
      productData.frameImageTB = l.texturTB || l.texturLR;
      productData.frameBreiteMM = l.breiteMM;
      productData.frameHoeheMM = l.hoeheMM;
      varianten = l.varianten || [];

      /* Die Matrix haengt an den Varianten — mit denen der neuen Leiste muss
         sie neu gebaut werden, sonst rechnet der Konfigurator weiter mit den
         Preisen und Massen der alten. */
      matrix = baueMatrix(varianten);
      ppOptionVorhanden = matrix.ppWerte.length > 1;
      matrix.eintraege = matrix.eintraege.filter(function (e) {
        return e.ppWert === null || e.ppWert === PP_OHNE || !!e.v.pp;
      });

      /* Die bisherige Wahl beibehalten, wo die neue Leiste sie hergibt. */
      if (!eintragVon(state.groesseKey, ppOptionVorhanden ? state.pp : null)) {
        var moeglich = groessenFuer(ppOptionVorhanden ? state.pp : null);
        if (moeglich.length) {
          state.groesseKey = naechsteGroesse(moeglich, state.groesseKey);
        } else {
          /* Diese Leiste kennt die gewaehlte Ausschnittzahl gar nicht. Dann
             auf die naechstgelegene ruecken, die sie anbietet — nicht auf die
             erste Variante im Sortiment. Die waere in Shopify-Reihenfolge
             ueblicherweise "Ohne", und drei hochgeladene Bilder waeren mit
             einem Klick weg. */
          var bisher = ausschnitteAusWert(state.pp);
          var beste = null;
          matrix.ppWerte.forEach(function (kandidat) {
            if (!groessenFuer(kandidat.wert).length) return;
            if (!beste || Math.abs(kandidat.anzahl - bisher) < Math.abs(beste.anzahl - bisher)) {
              beste = kandidat;
            }
          });
          if (beste) {
            state.pp = beste.wert;
            var passende = groessenFuer(beste.wert);
            if (passende.length) state.groesseKey = naechsteGroesse(passende, state.groesseKey);
          } else if (matrix.eintraege.length) {
            state.groesseKey = matrix.eintraege[0].groesseKey;
            state.pp = matrix.eintraege[0].ppWert;
          }
        }
      }
      if (els.leisteValue) els.leisteValue.textContent = l.titel;
      if (els.titel) els.titel.textContent = l.titel;

      renderLeisten();

      /* Geometrie, Slots, Kacheln, Vorschau und Masse in einem Zug — eine
         andere Leiste kann ein anderes Sortiment haben, bis hin zu einer
         anderen Zahl von Ausschnitten. */
      wechsle(state.groesseKey, state.pp, false);
      updateStepSubtitles();

      if (inUrl && window.history && window.history.pushState) {
        var v = aktuelleVariante();
        var url = new URL(l.url || ('/products/' + l.handle), window.location.origin);
        if (v) url.searchParams.set('variant', v.id);
        window.history.pushState(
          { sfcGroesse: state.groesseKey, sfcPp: state.pp, sfcQuer: state.wunschQuer, sfcLeiste: handle },
          '', url.toString());
      }
    }

    /* =================================================================
     * Format und Passepartout — beide bestimmen die Shopify-Variante
     * ================================================================= */

    /**
     * Uebernimmt eine Groessen- oder Passepartout-Aenderung: Geometrie,
     * Slot-Zahl, Vorschau, Preis, Masse und Variante werden neu gerechnet.
     *
     * @param {string|null} neueGroesse  Schluessel der Groesse, null = behalten
     * @param {string|null} neuesPp      Passepartout-Optionswert, null = behalten
     * @param {boolean} inUrl true = Wechsel in die Chronik schreiben, damit der
     *   Zurueck-Knopf des Browsers zur vorherigen Wahl fuehrt.
     */
    function wechsle(neueGroesse, neuesPp, inUrl) {
      if (neueGroesse) state.groesseKey = neueGroesse;

      if (neuesPp && neuesPp !== state.pp) {
        state.pp = neuesPp;
        /* Die Groesse gilt nur fuer manche Ausschnittzahlen. Passt sie nicht
           mehr, ruecken wir auf die naechste, die es gibt — statt eine
           Variante anzubieten, die niemand bestellen kann. */
        if (!eintragVon(state.groesseKey, state.pp)) {
          var moeglich = groessenFuer(state.pp);
          if (moeglich.length) state.groesseKey = naechsteGroesse(moeglich, state.groesseKey);
        }
      }

      var vorherAnzahl = state.slots.length;
      uebernehmeFormat();
      if (!geo) return;

      /* Ein Ausschnitt, ein Bild. Die Slots ziehen mit; vorhandene Bilder
         bleiben in ihren Slots stehen. */
      var slotZahlGeaendert = setzeSlotZahl(geo.anzahl);
      var rasterGeaendert = slotZahlGeaendert || state.slots.length > 1;

      /* Der Zuschnitt haengt am Seitenverhaeltnis des Fensters. Aendert sich
         Groesse, Passepartout oder Ausrichtung, muss er mitziehen.
         applyAlleCrops() rendert die Vorschau am Ende selbst neu. */
      var cropsLaufen = setzeCropsZurueck();

      if (rasterGeaendert) renderSlots();
      renderPpWahl();
      renderFormatKacheln();

      /* Manche Ausschnittzahlen haben nur ein Format — dann ist der Schritt
         eine Kachel ohne Wahl und verschwindet. Die Nummern und die
         Schrittleiste ziehen mit. */
      var stepFormatJetzt = $('sfc-step-format');
      if (stepFormatJetzt) {
        var nurEines = groessenFuer(ppOptionVorhanden ? state.pp : null).length < 2;
        if (stepFormatJetzt.hidden !== nurEines) {
          stepFormatJetzt.hidden = nurEines;
          nummeriereSchritte();
          syncTabSichtbarkeit();
          syncTabs();
        }
      }
      if (!cropsLaufen) renderPreview();
      updateSummary();
      updateStepSubtitles();
      updateQualityHint(true);
      syncOrientationUi();

      /* Wer die Ausschnittzahl erhoeht, braucht neue Bilder — die Seite zeigt
         dann wieder den Upload-Schritt, statt die leeren Ablagen zu verstecken. */
      if (state.slots.length > vorherAnzahl && hatBild()) {
        var schritt = $('sfc-step-upload');
        if (schritt) openStep(schritt);
      }

      sichereZustand();
      if (inUrl) schreibeUrl(true);
    }

    /** Naechstgelegene Groesse nach Flaeche — bei einem Wechsel springt es so am wenigsten. */
    function naechsteGroesse(kandidaten, bisher) {
      var bisherEintrag = null;
      for (var i = 0; i < matrix.groessen.length; i++) {
        if (matrix.groessen[i].key === bisher) bisherEintrag = matrix.groessen[i];
      }
      if (!bisherEintrag) return kandidaten[0].key;

      var ziel = flaecheAusLabel(bisherEintrag.label);
      var beste = kandidaten[0];
      var besterAbstand = Infinity;
      kandidaten.forEach(function (g) {
        var abstand = Math.abs(flaecheAusLabel(g.label) - ziel);
        if (abstand < besterAbstand) { besterAbstand = abstand; beste = g; }
      });
      return beste.key;
    }

    /**
     * Setzt die Zuschnitte aller Slots auf das neue Seitenverhaeltnis und
     * startet sie neu.
     *
     * @returns {boolean} true, wenn mindestens ein Zuschnitt laeuft — dann
     *   rendert applyAlleCrops die Vorschau, der Aufrufer darf es nicht auch.
     */
    function setzeCropsZurueck() {
      if (!geo) return false;
      var betroffen = [];
      state.slots.forEach(function (s, i) {
        if (!s.original) return;
        s.crop = maxCenteredCrop(s.original.width, s.original.height, geo.ratio);
        betroffen.push(i);
      });
      if (!betroffen.length) return false;
      applyAlleCrops(betroffen);
      return true;
    }

    function groesseNachKey(key) {
      for (var i = 0; i < matrix.groessen.length; i++) {
        if (matrix.groessen[i].key === key) return matrix.groessen[i];
      }
      return null;
    }

    /**
     * Haelt ?variant= in der URL aktuell, damit die Wahl teilbar ist und der
     * Zurueck-Knopf funktioniert.
     */
    function schreibeUrl(neuerEintrag) {
      var v = aktuelleVariante();
      if (!v || !window.history || !window.history.pushState) return;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      var zustand = { sfcGroesse: state.groesseKey, sfcPp: state.pp, sfcQuer: state.wunschQuer };
      if (neuerEintrag) window.history.pushState(zustand, '', url.toString());
      else window.history.replaceState(zustand, '', url.toString());
    }

    /** Liest die Variante aus ?variant= der aktuellen URL. */
    function ausUrl() {
      var id = new URL(window.location.href).searchParams.get('variant');
      if (!id) return null;
      for (var i = 0; i < varianten.length; i++) {
        if (String(varianten[i].id) === String(id)) return varianten[i];
      }
      return null;
    }

    /** Groessen- und Passepartout-Wahl, die zu einer Variante gehoeren. */
    function wahlAusVariante(v) {
      var wahl = { groesse: null, pp: null };
      if (!v) return wahl;
      for (var i = 0; i < matrix.eintraege.length; i++) {
        if (String(matrix.eintraege[i].v.id) === String(v.id)) {
          wahl.groesse = matrix.eintraege[i].groesseKey;
          wahl.pp = matrix.eintraege[i].ppWert;
          return wahl;
        }
      }
      return wahl;
    }

    /** Die Variante zur aktuellen Wahl. Faellt auf die Startvariante zurueck. */
    function aktuelleVariante() {
      var eintrag = eintragVon(state.groesseKey, ppOptionVorhanden ? state.pp : null);
      return eintrag ? eintrag.v : startVariante;
    }

    /** Preis der aktuellen Wahl in Cent. */
    function aktuellerPreis() {
      var v = aktuelleVariante();
      return v && typeof v.preis === 'number' ? v.preis : productData.price;
    }

    /**
     * Aussenmass in cm: Passepartout-Aussenmass plus Leiste auf beiden Seiten.
     * Die Leiste ist links/rechts custom.breite und oben/unten custom.hohe —
     * bei Leisten mit abweichender Bauhoehe sind das verschiedene Werte.
     */
    function aussenmass(g) {
      var b = toNumber(productData.frameBreiteMM, 24) / 10;
      var h = toNumber(productData.frameHoeheMM, b * 10) / 10;
      return { breite: g.aussenB + 2 * b, hoehe: g.aussenH + 2 * h };
    }

    /** Geometrie eines beliebigen Eintrags, ohne den aktuellen Zustand zu aendern. */
    function geometrieVon(eintrag) {
      if (!eintrag) return null;
      var pp = ppDerVariante(eintrag.v.pp, eintrag.groesseLabel, state.wunschQuer);
      return pp ? computeGeometry(pp) : null;
    }

    /**
     * Baut die Formatkacheln: Aussenmass des Passepartouts, Aussenmass mit
     * Leiste, Gesamtpreis.
     *
     * Gezeigt werden nur Groessen, die es zur gewaehlten Ausschnittzahl gibt.
     * Bewusst ausblenden statt ausgrauen: bei "3 Ausschnitte" waeren fuenf von
     * sieben Kacheln tot, und eine Liste, die zu drei Vierteln aus
     * Unmoeglichem besteht, liest sich als Fehler.
     */
    function renderFormatKacheln() {
      if (!els.formatKacheln) return;
      els.formatKacheln.innerHTML = '';

      groessenFuer(ppOptionVorhanden ? state.pp : null).forEach(function (groesse) {
        var eintrag = eintragVon(groesse.key, ppOptionVorhanden ? state.pp : null);
        if (!eintrag) return;

        var g = geometrieVon(eintrag);
        if (!g) return;
        var aussen = aussenmass(g);
        var gewaehlt = groesse.key === state.groesseKey;
        var lieferbar = eintrag.v.verfuegbar !== false;

        var knopf = document.createElement('button');
        knopf.type = 'button';
        knopf.className = 'sfc-format' + (gewaehlt ? ' sfc-format--aktiv' : '');
        knopf.setAttribute('role', 'radio');
        knopf.setAttribute('aria-checked', gewaehlt ? 'true' : 'false');
        knopf.setAttribute('data-format', groesse.key);

        /* Nicht lieferbar heisst auch nicht waehlbar. Vorher trug die Kachel
           nur eine blassere Farbe, liess sich aber anklicken und setzte eine
           unbestellbare Variante — samt aktivem Kaufknopf. */
        if (!lieferbar) {
          knopf.classList.add('sfc-format--weg');
          knopf.disabled = true;
          knopf.setAttribute('aria-disabled', 'true');
        }

        /* Sichtbarer Auswahlpunkt: die Kachel ist ein Radio, das soll man ihr
           auch ansehen — bisher trug die Wahl allein die Rahmenfarbe. */
        var punkt = document.createElement('span');
        punkt.className = 'sfc-format__punkt';
        punkt.setAttribute('aria-hidden', 'true');

        var links = document.createElement('span');
        links.className = 'sfc-format__text';

        var titel = document.createElement('span');
        titel.className = 'sfc-format__titel';
        titel.textContent = formatCm(g.aussenB) + ' × ' + formatCm(g.aussenH) + ' cm';

        var aussenZeile = document.createElement('span');
        aussenZeile.className = 'sfc-format__aussen';
        aussenZeile.textContent = 'Außenmaß mit Leiste: ' +
          formatCm(aussen.breite) + ' × ' + formatCm(aussen.hoehe) + ' cm';

        links.appendChild(titel);
        links.appendChild(aussenZeile);

        if (!lieferbar) {
          var weg = document.createElement('span');
          weg.className = 'sfc-format__knapp';
          weg.textContent = 'Zur Zeit nicht lieferbar';
          links.appendChild(weg);
        } else if (hatBild() && dpiFuer(eintrag) < LOW_PRINT_DPI) {
          /* Dezenter Hinweis, wenn das Bild fuer dieses Format zu klein ist —
             an der Kachel und nicht als weitere Warnzeile. */
          var knapp = document.createElement('span');
          knapp.className = 'sfc-format__knapp';
          knapp.textContent = 'Für dein Foto zu groß';
          links.appendChild(knapp);
        }

        var preis = document.createElement('span');
        preis.className = 'sfc-format__preis';
        preis.textContent = formatMoney(eintrag.v.preis);

        knopf.appendChild(punkt);
        knopf.appendChild(links);
        knopf.appendChild(preis);
        els.formatKacheln.appendChild(knopf);
      });
    }

    /**
     * Baut die Passepartout-Kacheln: eine je Ausschnittzahl, dazu "Ohne".
     *
     * Alle bleiben immer waehlbar — zu jeder Ausschnittzahl gibt es mindestens
     * eine Groesse. Passt die aktuelle Groesse nicht dazu, wechselt sie mit
     * (siehe wechsle). Die Ausschnittzahl ist damit die Hauptentscheidung und
     * die Groesse folgt ihr, nicht umgekehrt.
     */
    function renderPpWahl() {
      if (!els.ppWahl) return;
      if (!ppOptionVorhanden) { els.ppWahl.hidden = true; return; }
      els.ppWahl.hidden = false;
      els.ppWahl.innerHTML = '';

      /* Preise beziehen sich auf die jeweils passende Groesse: zur aktuellen,
         wenn es sie gibt, sonst auf die, die beim Wechsel gewaehlt wuerde.
         Ein Preis fuer eine Kombination, die gar nicht existiert, waere eine
         Zahl, die der Kunde nie zu sehen bekommt. */
      var basisPreis = null;
      var aktuellerEintrag = eintragVon(state.groesseKey, state.pp);
      if (aktuellerEintrag) basisPreis = aktuellerEintrag.v.preis;

      matrix.ppWerte.forEach(function (opt) {
        var eintrag = eintragVon(state.groesseKey, opt.wert);
        var gewechselt = false;
        if (!eintrag) {
          var moeglich = groessenFuer(opt.wert);
          if (!moeglich.length) return;
          eintrag = eintragVon(naechsteGroesse(moeglich, state.groesseKey), opt.wert);
          gewechselt = true;
        }
        if (!eintrag) return;

        var gewaehlt = state.pp === opt.wert;

        var knopf = document.createElement('button');
        knopf.type = 'button';
        knopf.className = 'sfc-ppwahl__option' + (gewaehlt ? ' sfc-ppwahl__option--aktiv' : '');
        knopf.setAttribute('role', 'radio');
        knopf.setAttribute('aria-checked', gewaehlt ? 'true' : 'false');
        knopf.setAttribute('data-pp', opt.wert);

        var raster = document.createElement('span');
        raster.className = 'sfc-ppwahl__raster';
        raster.setAttribute('aria-hidden', 'true');
        raster.innerHTML = ppPiktogramm(eintrag);
        knopf.appendChild(raster);

        var name = document.createElement('span');
        name.className = 'sfc-ppwahl__name';
        name.textContent = opt.anzahl === 0 ? 'Ohne Passepartout' : opt.wert;
        knopf.appendChild(name);

        /* Zwei Bilder wollen zwei Uploads — das soll vor dem Klick dastehen
           und nicht erst danach als drei leere Ablagen auffallen. */
        if (opt.anzahl > 1) {
          var hinweis = document.createElement('span');
          hinweis.className = 'sfc-ppwahl__sub';
          hinweis.textContent = opt.anzahl + ' Bilder';
          knopf.appendChild(hinweis);
        } else if (gewechselt) {
          var wechselHinweis = document.createElement('span');
          wechselHinweis.className = 'sfc-ppwahl__sub';
          wechselHinweis.textContent = 'dann ' + groessenLabel(eintrag);
          knopf.appendChild(wechselHinweis);
        }

        /* Preisdifferenz zur aktuellen Wahl, benannt und nicht als Rabatt
           inszeniert. Bei gleichem Preis steht nichts da. */
        if (basisPreis !== null && !gewaehlt && typeof eintrag.v.preis === 'number') {
          var diff = eintrag.v.preis - basisPreis;
          if (diff !== 0) {
            var d = document.createElement('span');
            d.className = 'sfc-ppwahl__diff';
            d.textContent = (diff > 0 ? '+' : '−') + formatMoney(Math.abs(diff));
            knopf.appendChild(d);
          }
        }

        els.ppWahl.appendChild(knopf);
      });

      // Ohne Passepartout gibt es keine Farbe zu waehlen.
      if (els.matFarbeBlock) els.matFarbeBlock.hidden = state.pp === PP_OHNE;
    }

    /** Miniatur des Ausschnitt-Rasters fuer eine Passepartout-Kachel. */
    function ppPiktogramm(eintrag) {
      var g = geometrieVon(eintrag);
      if (!g) return '';

      /* Massstaeblich, damit die Kachel die echten Proportionen zeigt: ein
         66,5 x 22,5 cm langes Dreifach-Passepartout sieht dann auch lang aus. */
      var skala = 30 / Math.max(g.aussenB, g.aussenH);
      var b = g.aussenB * skala;
      var h = g.aussenH * skala;
      var loecher = '';
      g.fenster.forEach(function (f) {
        loecher += '<rect x="' + (f.x * skala) + '" y="' + (f.y * skala) +
          '" width="' + (f.b * skala) + '" height="' + (f.h * skala) +
          '" fill="currentColor" opacity="0.85"/>';
      });

      return '<svg viewBox="0 0 ' + b + ' ' + h + '" width="' + b + '" height="' + h + '" ' +
        'aria-hidden="true"><rect x="0" y="0" width="' + b + '" height="' + h +
        '" fill="none" stroke="currentColor" stroke-width="' + (0.6) + '" opacity="0.45"/>' +
        loecher + '</svg>';
    }

    /** URL des aktuell gewaehlten Beispielbildes, oder '' wenn keins gepflegt ist. */
    function beispielUrl() {
      var eintrag = beispiele[state.beispielIndex] || beispiele[0];
      return eintrag && eintrag.url ? eintrag.url : '';
    }

    /** Wechselt das Beispielbild. Nur wirksam, solange kein eigenes Bild da ist. */
    function setzeBeispiel(index) {
      if (index < 0 || index >= beispiele.length) return;
      state.beispielIndex = index;
      markiereBeispielAuswahl();
      renderPreview();
    }

    function markiereBeispielAuswahl() {
      if (!els.beispiele) return;
      /* Die Beispielreihe verschwindet, sobald das erste eigene Bild da ist —
         sie fuellt dann ohnehin nur noch die restlichen Ausschnitte. */
      var aktiv = !hatBild();
      els.beispiele.hidden = !aktiv;
      var knoepfe = els.beispiele.querySelectorAll('[data-beispiel-index]');
      for (var i = 0; i < knoepfe.length; i++) {
        var gewaehlt = aktiv && parseInt(knoepfe[i].getAttribute('data-beispiel-index'), 10) === state.beispielIndex;
        knoepfe[i].classList.toggle('sfc-beispiel--aktiv', gewaehlt);
        knoepfe[i].setAttribute('aria-pressed', gewaehlt ? 'true' : 'false');
      }
    }

    /* ---------------- Galerie ---------------- */

    /** Index des Slides, der gerade im Streifen steht (0 = Rahmung). */
    function galerieIndex() {
      if (!els.slider || !els.slider.clientWidth) return 0;
      return Math.round(els.slider.scrollLeft / els.slider.clientWidth);
    }

    function galerieAnzahl() {
      return els.slider ? els.slider.querySelectorAll('.sfc__slide').length : 0;
    }

    /** Punkte und Pfeile auf den sichtbaren Slide setzen. */
    function markiereSlide(index) {
      if (els.punkte) {
        var punkte = els.punkte.querySelectorAll('.sfc__punkt');
        for (var i = 0; i < punkte.length; i++) {
          var aktiv = i === index;
          punkte[i].classList.toggle('sfc__punkt--aktiv', aktiv);
          if (aktiv) punkte[i].setAttribute('aria-current', 'true');
          else punkte[i].removeAttribute('aria-current');
        }
      }
      if (els.galerieZurueck) els.galerieZurueck.disabled = index <= 0;
      if (els.galerieWeiter) els.galerieWeiter.disabled = index >= galerieAnzahl() - 1;
    }

    /* Der zuletzt angesteuerte Slide. Die Pfeile rechnen damit und nicht mit
       der gemessenen Position: waehrend eine weiche Bewegung laeuft, stuende
       dort ein Zwischenwert und der zweite schnelle Tap bliebe wirkungslos. */
    var galerieZiel = 0;

    function scrolleZuSlide(index) {
      if (!els.slider) return;
      var ziel = Math.max(0, Math.min(index, galerieAnzahl() - 1));
      var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      galerieZiel = ziel;
      els.slider.scrollTo({ left: ziel * els.slider.clientWidth, behavior: ruhig ? 'auto' : 'smooth' });
      markiereSlide(ziel);
    }

    /** Zurueck zur Rahmung, falls der Streifen gerade ein Produktfoto zeigt. */
    function zeigeRahmung() {
      if (els.slider && galerieIndex() !== 0) scrolleZuSlide(0);
    }

    function renderPreview() {
      if (typeof window.generateFramePreviewSvg !== 'function') {
        console.warn('[SFC] generateFramePreviewSvg nicht verfuegbar');
        return;
      }
      if (!geo) return;

      var matColor = mattFarben().filter(function (c) { return c.color === state.matColor; })[0] || SFC_MAT_COLORS[0];
      var beispiel = beispielUrl();

      /* Ein Fenster, ein Bild. Noch leere Ausschnitte fuellt das Beispielbild:
         die Seite zeigt damit von der ersten Sekunde an eine fertige Rahmung
         und nie ein Loch. */
      var zeigtBeispiel = false;
      var cutouts = geo.fenster.map(function (f, i) {
        var s = state.slots[i];
        var eigenes = s ? (s.croppedBlobUrl || (s.original && s.original.blobUrl)) : null;
        if (!eigenes && beispiel) zeigtBeispiel = true;
        return { x: f.x, y: f.y, w: f.b, h: f.h, imageUrl: eigenes || beispiel || '' };
      });

      var hatIrgendeinBild = cutouts.some(function (c) { return !!c.imageUrl; });
      var ohnePp = istOhnePp(geo);

      var svg;
      try {
        svg = window.generateFramePreviewSvg({
          imageUrl: cutouts.length ? cutouts[0].imageUrl : '',
          frameConfig: {
            productId: productData.productId,
            frameImageLR: productData.frameImageLR || '',
            frameImageTB: productData.frameImageTB || productData.frameImageLR || '',
            frameWidth: productData.frameBreiteMM || 24
          },
          matConfig: {
            type: ohnePp ? 'none' : 'standard',
            width: 'individual',
            color: state.matColor,
            colorImageUrl: matColor.imageUrl,
            /* Ohne Passepartout bleibt es beim alten Ein-Fenster-Pfad: dort
               ist "dimensions" das Motivmass und es gibt nichts zu schneiden. */
            cutouts: ohnePp ? null : cutouts
          },
          dimensions: ohnePp
            ? { width: geo.fenster[0].b, height: geo.fenster[0].h }
            : { width: geo.aussenB, height: geo.aussenH },
          rotation: 0
        });
      } catch (err) {
        console.error('[SFC] Vorschau konnte nicht erzeugt werden:', err);
        return;
      }

      els.preview.innerHTML = svg;

      /* Die Markierung gehoert zum Beispielzustand und verschwindet, sobald
         alle Ausschnitte ein eigenes Bild tragen. Sie liegt im Slide, nicht in
         #sfc-preview — sonst raeumt innerHTML sie weg. */
      if (els.beispielHinweis) {
        var hinweis = els.beispielHinweis;
        /* Den eingestellten Text einmalig sichern, bevor er ueberschrieben
           wird — sonst liest der Rueckweg sein eigenes Ergebnis zurueck und
           "Restliche Ausschnitte" bleibt fuer immer stehen. */
        if (!hinweis.dataset.standard) hinweis.dataset.standard = hinweis.textContent;
        hinweis.hidden = !zeigtBeispiel;
        hinweis.textContent = (zeigtBeispiel && hatBild())
          ? 'Restliche Ausschnitte: Beispielbild'
          : hinweis.dataset.standard;
      }

      /* Nach jeder Aenderung zurueck zur Rahmung: wer Leiste, Format oder
         Passepartout wechselt, will das Ergebnis sehen — nicht das
         Produktfoto, auf dem der Streifen gerade stand. */
      zeigeRahmung();
      els.preview.classList.toggle('sfc__preview--has-image', hatIrgendeinBild);
      els.preview.classList.toggle('sfc__preview--beispiel', zeigtBeispiel);
    }

    /* ---------------- Ausrichtung ---------------- */

    /** Ist die aktuelle Rahmung hoch oder quer? Ergibt sich aus dem Aussenmass. */
    function istHochformat() {
      return geo ? geo.aussenH >= geo.aussenB : true;
    }

    /** Spiegelt die Ausrichtung in die Oberflaeche — ohne Neuberechnung des Ausschnitts. */
    function syncOrientationUi() {
      if (!geo) return;
      var hoch = istHochformat();

      if (els.orientationOptions) {
        var buttons = els.orientationOptions.querySelectorAll('[data-orientation]');
        for (var i = 0; i < buttons.length; i++) {
          var willHoch = buttons[i].dataset.orientation === 'portrait';
          var isActive = willHoch === hoch;
          buttons[i].classList.toggle('sfc-option-btn--active', isActive);
          buttons[i].setAttribute('aria-checked', isActive ? 'true' : 'false');

          /* Die Untertitel zeigen, was der Klick bewirkt: das Aussenmass in
             der jeweiligen Lage. Gedreht wird das ganze Blatt, also tauschen
             Breite und Hoehe. */
          var sub = buttons[i].querySelector('[data-orient-dims]');
          if (sub) {
            var b = isActive ? geo.aussenB : geo.aussenH;
            var h = isActive ? geo.aussenH : geo.aussenB;
            sub.textContent = formatCm(b) + ' × ' + formatCm(h) + ' cm';
          }
        }
      }
      if (els.orientationValue) {
        els.orientationValue.textContent = hoch ? 'Hochformat' : 'Querformat';
      }
      if (els.formatLabel) {
        els.formatLabel.textContent = formatCm(geo.aussenB) + ' × ' + formatCm(geo.aussenH) + ' cm';
      }
    }

    /**
     * Dreht die Rahmung in die gewuenschte Lage.
     *
     * Gedreht wird das gesamte Passepartout: aus zwei Fenstern nebeneinander
     * werden zwei uebereinander, und die Fenster kippen mit. Physisch ist das
     * dasselbe Blatt, nur anders gehaengt — deshalb bleibt es dieselbe
     * Variante und derselbe Preis.
     */
    function setOrientation(orientation, byUser) {
      if (orientation !== 'portrait' && orientation !== 'landscape') return;
      if (!geo) return;

      var willQuer = orientation === 'landscape';

      // Gleiche Ausrichtung erneut gewaehlt: nur die Absicht merken, aber den vom
      // Kunden gewaehlten Ausschnitt NICHT zurueckwerfen.
      if (state.wunschQuer === willQuer && state.orientationInitialised) {
        if (byUser) state.orientationTouchedByUser = true;
        return;
      }
      state.orientationInitialised = true;
      state.wunschQuer = willQuer;
      if (byUser) state.orientationTouchedByUser = true;

      uebernehmeFormat();
      if (!geo) return;

      syncOrientationUi();
      renderFormatKacheln();
      renderPpWahl();

      /* Das Raster kippt mit, also auch die Piktogramme in den Ablagen. */
      if (state.slots.length > 1) renderSlots();

      // Ausschnitte an das neue Seitenverhaeltnis anpassen
      if (!setzeCropsZurueck()) renderPreview();
      updateSummary();
      updateStepSubtitles();
      sichereZustand();
    }

    /** Groesstmoegliches zentriertes Rechteck mit gegebenem Seitenverhaeltnis. */
    function maxCenteredCrop(sourceW, sourceH, ratio) {
      var w = sourceW;
      var h = w / ratio;
      if (h > sourceH) {
        h = sourceH;
        w = h * ratio;
      }
      return {
        x: Math.round((sourceW - w) / 2),
        y: Math.round((sourceH - h) / 2),
        w: Math.round(w),
        h: Math.round(h)
      };
    }

    /* ---------------- Zuschneiden anwenden ---------------- */

    /**
     * Rendert das Crop-Rechteck EINES Slots auf ein Canvas.
     *
     * Wichtig: Die Invalidierung passiert SYNCHRON hier oben — nicht in den Aufrufern und
     * nicht im toBlob-Callback. Sonst kann "In den Warenkorb" waehrend eines laufenden
     * Zuschnitts die alte Firebase-URL wiederverwenden und ein falsches Bild bestellen.
     *
     * Der Zaehler cropToken liegt bewusst am Slot und nicht global: bei vier
     * gleichzeitig laufenden Zuschnitten wuerde ein gemeinsamer Zaehler alle
     * bis auf den zuletzt gestarteten verwerfen.
     *
     * @param {number} index      Slot
     * @param {boolean} [stumm]   true = Vorschau nicht neu rendern (macht der Aufrufer)
     * @returns {Promise} erfuellt, sobald der Blob zum aktuellen Crop passt
     */
    function applyCrop(index, stumm) {
      var i = index == null ? state.aktiverSlot : index;
      var s = state.slots[i];
      if (!s) return Promise.resolve();

      s.croppedDirty = true;
      s.croppedRemoteUrl = null;
      s.croppedBlob = null;

      if (!s.original || !s.crop) {
        if (!stumm) renderPreview();
        s.cropPromise = Promise.resolve();
        return s.cropPromise;
      }

      var token = ++s.cropToken;
      var crop = s.crop;

      s.cropPromise = new Promise(function (resolve, reject) {
        var image = new Image();

        image.onload = function () {
          if (token !== s.cropToken) { resolve(); return; }

          // Safari (iOS wie macOS) begrenzt die Canvas-Flaeche auf 16.777.216 px.
          // Darueber bleibt der Canvas schwarz — also notfalls herunterskalieren.
          var scale = 1;
          var area = crop.w * crop.h;
          var MAX_CANVAS_AREA = 16777216;
          if (area > MAX_CANVAS_AREA) scale = Math.sqrt(MAX_CANVAS_AREA / area);

          var canvas = document.createElement('canvas');
          canvas.width = Math.max(1, Math.round(crop.w * scale));
          canvas.height = Math.max(1, Math.round(crop.h * scale));
          var ctx = canvas.getContext('2d');

          try {
            ctx.drawImage(image, crop.x, crop.y, crop.w, crop.h, 0, 0, canvas.width, canvas.height);
          } catch (err) {
            if (!stumm) renderPreview();
            reject(new Error('Das Bild konnte nicht zugeschnitten werden.'));
            return;
          }

          canvas.toBlob(function (blob) {
            if (token !== s.cropToken) { resolve(); return; }
            if (!blob) {
              if (!stumm) renderPreview();
              reject(new Error('Das Bild konnte nicht zugeschnitten werden.'));
              return;
            }

            if (s.croppedBlobUrl) URL.revokeObjectURL(s.croppedBlobUrl);
            s.croppedBlobUrl = URL.createObjectURL(blob);
            s.croppedBlob = blob;

            zeigeSlot(i);
            if (!stumm) {
              renderPreview();
              updateQualityHint();
            }
            resolve();
          }, 'image/jpeg', 0.92);
        };

        image.onerror = function () {
          if (token !== s.cropToken) { resolve(); return; }
          if (!stumm) renderPreview();
          reject(new Error('Das Originalbild konnte nicht gelesen werden.'));
        };

        image.src = s.original.blobUrl;
      });

      // Verhindert unhandled rejections — der Fehler wird beim Warenkorb-Klick ausgewertet.
      s.cropPromise.catch(function () {});
      return s.cropPromise;
    }

    /**
     * Schneidet mehrere Slots zu und rendert die Vorschau GENAU EINMAL am Ende.
     *
     * Ohne das baut ein Formatwechsel bei vier Bildern vier SVGs hintereinander
     * auf — sichtbar als Flackern, und drei davon sind sofort veraltet.
     */
    function applyAlleCrops(indizes) {
      var liste = indizes || state.slots.map(function (_, i) { return i; });
      var laeufe = liste.map(function (i) { return applyCrop(i, true).catch(function () {}); });
      return Promise.all(laeufe).then(function () {
        renderPreview();
        updateQualityHint();
      });
    }

    /**
     * Aufloesung eines Ausschnitts, in dpi am fertigen Druck. Bewusst ueber
     * BEIDE Achsen: nur die Breite zu pruefen ist im Querformat systematisch
     * zu optimistisch, weil dort die kurze Bildseite die lange Motivseite
     * fuellen muss.
     *
     * Bei mehreren Ausschnitten zaehlt das SCHLECHTESTE Bild — wenn eines von
     * vier unscharf wird, ist die Rahmung unscharf.
     *
     * @param {object} eintrag  Matrixeintrag; ohne Angabe die aktuelle Wahl
     */
    function dpiFuer(eintrag) {
      var g = eintrag ? geometrieVon(eintrag) : geo;
      if (!g) return null;

      var schlechtester = null;
      state.slots.forEach(function (s) {
        if (!s.crop) return;
        var dpi = Math.min(s.crop.w / (g.ausschnittB / 2.54),
                           s.crop.h / (g.ausschnittH / 2.54));
        if (schlechtester === null || dpi < schlechtester) schlechtester = dpi;
      });
      return schlechtester;
    }

    /** Waehlbare Groessen der aktuellen Ausschnittzahl, groesste zuerst. */
    function formateNachFlaeche() {
      return groessenFuer(ppOptionVorhanden ? state.pp : null)
        .map(function (g) { return eintragVon(g.key, ppOptionVorhanden ? state.pp : null); })
        .filter(Boolean)
        .sort(function (a, b) {
          return flaecheAusLabel(b.groesseLabel) - flaecheAusLabel(a.groesseLabel);
        });
    }

    /** Anzeigename einer Groesse: das echte Aussenmass in der aktuellen Lage. */
    function groessenLabel(eintrag) {
      var g = geometrieVon(eintrag);
      return g ? (formatCm(g.aussenB) + ' × ' + formatCm(g.aussenH) + ' cm') : eintrag.groesseLabel;
    }

    /**
     * Aufloesungspruefung mit Ausweg statt Sperre. Der Kunde darf immer weiter;
     * klickt er "Trotzdem", merkt sich der Konfigurator das und gibt es als
     * _aufloesung_ok an die Werkstatt weiter.
     *
     * Im Haupttext steht keine dpi-Zahl — der Kunde will die Folge wissen,
     * nicht die Kennzahl. Sie steht im Aufklapper.
     *
     * @param {boolean} [ohneKacheln] true, wenn der Aufrufer die Formatkacheln
     *   ohnehin schon neu gebaut hat — sonst rendert wechsle() sie doppelt.
     */
    function updateQualityHint(ohneKacheln) {
      if (!els.uploadQuality) return;
      if (!hatBild() || !geo) { els.uploadQuality.hidden = true; return; }

      var dpiAktuell = dpiFuer(null);
      if (dpiAktuell === null) { els.uploadQuality.hidden = true; return; }

      var aktuellerEintrag = eintragVon(state.groesseKey, ppOptionVorhanden ? state.pp : null);
      var label = aktuellerEintrag ? groessenLabel(aktuellerEintrag) : 'diesem Format';
      var waehlbar = formateNachFlaeche();

      // Groesstes Format, das noch reicht — das ist das Ziel des Auswegs.
      var passend = null;
      waehlbar.forEach(function (e) {
        if (!passend && dpiFuer(e) >= LOW_PRINT_DPI) passend = e;
      });

      // Reicht es fuer jedes angebotene Format?
      var reichtUeberall = waehlbar.every(function (e) {
        return dpiFuer(e) >= LOW_PRINT_DPI;
      });

      els.uploadQuality.innerHTML = '';
      els.uploadQuality.classList.toggle('sfc-upload__quality--low', dpiAktuell < LOW_PRINT_DPI);
      els.uploadQuality.classList.toggle('sfc-upload__quality--ok', dpiAktuell >= LOW_PRINT_DPI);
      els.uploadQuality.hidden = false;

      var text = document.createElement('p');
      text.className = 'sfc-quality__text';

      /* Bei mehreren Bildern gilt das schwaechste — das muss dastehen, sonst
         sucht der Kunde den Fehler beim falschen Foto. */
      var mehrere = state.slots.filter(function (s) { return !!s.crop; }).length > 1;
      var schwaechstes = mehrere ? schwaechsterSlot() : -1;

      if (dpiAktuell >= LOW_PRINT_DPI) {
        state.aufloesungBestaetigt = false;
        text.textContent = reichtUeberall && waehlbar.length > 1
          ? 'Auflösung passt. ' + (mehrere ? 'Alle Bilder werden' : 'Dieses Foto wird') + ' in jedem Format scharf.'
          : 'Auflösung passt.';
        els.uploadQuality.appendChild(text);
      } else {
        var wessen = mehrere ? ('Bild ' + (schwaechstes + 1) + ' ist') : 'Dieses Foto ist';
        if (passend && passend !== aktuellerEintrag) {
          text.textContent = wessen + ' für ' + label + ' zu klein — gedruckt würde es unscharf. In ' +
            groessenLabel(passend) + ' sieht es gut aus.';
        } else {
          text.textContent = wessen + ' für ' + label + ' zu klein — gedruckt würde es unscharf.';
        }
        els.uploadQuality.appendChild(text);

        var aktionen = document.createElement('div');
        aktionen.className = 'sfc-quality__aktionen';

        if (passend && passend !== aktuellerEintrag) {
          var ziel = passend;
          var wechselKnopf = document.createElement('button');
          wechselKnopf.type = 'button';
          wechselKnopf.className = 'sfc-quality__knopf sfc-quality__knopf--primaer';
          wechselKnopf.textContent = 'Auf ' + groessenLabel(ziel) + ' wechseln';
          wechselKnopf.addEventListener('click', function () { wechsle(ziel.groesseKey, null, true); });
          aktionen.appendChild(wechselKnopf);
        }

        var trotzdem = document.createElement('button');
        trotzdem.type = 'button';
        trotzdem.className = 'sfc-quality__knopf';
        trotzdem.textContent = 'Trotzdem in ' + label;
        trotzdem.addEventListener('click', function () {
          state.aufloesungBestaetigt = true;
          els.uploadQuality.classList.add('sfc-upload__quality--akzeptiert');
          text.textContent = 'Alles klar — wir drucken es in ' + label + '. ' +
            'Unsere Werkstatt sieht den Hinweis mit deiner Bestellung.';
          aktionen.remove();
        });
        aktionen.appendChild(trotzdem);
        els.uploadQuality.appendChild(aktionen);
      }

      /* Die Zahl gehoert in den Aufklapper, nicht in den Haupttext. */
      var erklaerung = document.createElement('details');
      erklaerung.className = 'sfc-quality__erklaerung';
      var titel = document.createElement('summary');
      titel.textContent = 'Was heißt das?';
      var inhalt = document.createElement('p');
      inhalt.textContent = 'Wir rechnen, wie viele Bildpunkte pro Zoll auf dem fertigen Druck landen. ' +
        'Ab ' + LOW_PRINT_DPI + ' dpi wirkt ein Druck scharf, ab ' + GOOD_PRINT_DPI + ' dpi auch aus der Nähe. ' +
        (mehrere ? 'Dein schwächster Ausschnitt liegt' : 'Dein Ausschnitt liegt') +
        ' bei rund ' + Math.round(dpiAktuell) + ' dpi.';
      erklaerung.appendChild(titel);
      erklaerung.appendChild(inhalt);
      els.uploadQuality.appendChild(erklaerung);

      // Hinweis an der Kachel des Formats, für das es nicht reicht
      if (!ohneKacheln) renderFormatKacheln();
    }

    /** Slot mit der schlechtesten Aufloesung — der bestimmt das Ergebnis. */
    function schwaechsterSlot() {
      if (!geo) return -1;
      var schlechtester = -1;
      var wert = Infinity;
      state.slots.forEach(function (s, i) {
        if (!s.crop) return;
        var dpi = Math.min(s.crop.w / (geo.ausschnittB / 2.54), s.crop.h / (geo.ausschnittH / 2.54));
        if (dpi < wert) { wert = dpi; schlechtester = i; }
      });
      return schlechtester;
    }

    /* ---------------- Passepartout-Farben ---------------- */

    /**
     * Die waehlbaren Passepartout-Farben.
     *
     * Grundstock sind die vier gefuehrten Kartons mit Namen und Texturbild.
     * Das Produkt-Metafeld custom.passepartout_farben haelt nur Hex-Werte —
     * ohne Namen und ohne Karton-Optik. Farben daraus, die einem gefuehrten
     * Karton entsprechen, sind schon da; alle anderen kommen als reine
     * Flaechenfarbe dazu, und nur wenn das Section-Setting es erlaubt.
     */
    function mattFarben() {
      var liste = SFC_MAT_COLORS.slice();
      var zusatz = productData.farbenAusMetafeld;
      if (!zusatz || !zusatz.length) return liste;

      zusatz.forEach(function (hex, i) {
        var wert = String(hex || '').trim().toLowerCase();
        if (!/^#[0-9a-f]{3,8}$/.test(wert)) return;
        var bekannt = liste.some(function (c) { return c.hex.toLowerCase() === wert; });
        if (bekannt) return;
        liste.push({
          color: 'eigen-' + wert.replace('#', ''),
          displayName: 'Sonderfarbe ' + (i + 1),
          hex: wert,
          imageUrl: null
        });
      });
      return liste;
    }

    function renderMatSwatches() {
      if (!els.matColors) return;
      els.matColors.innerHTML = '';

      mattFarben().forEach(function (option) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'sfc-swatch' + (option.color === state.matColor ? ' sfc-swatch--active' : '');
        button.dataset.matColor = option.color;
        button.setAttribute('role', 'radio');
        button.setAttribute('aria-checked', option.color === state.matColor ? 'true' : 'false');
        button.setAttribute('aria-label', option.displayName);
        button.title = option.displayName;

        // Farbkachel wie im grossen Konfigurator: 44px, Beschriftung nur als
        // Tooltip und im Step-Untertitel — sonst wird die Zeile unruhig.
        var chip = document.createElement('span');
        chip.className = 'sfc-swatch__chip';
        chip.style.backgroundColor = option.hex;
        if (option.imageUrl) {
          chip.style.backgroundImage = 'url("' + option.imageUrl + '")';
        }

        button.appendChild(chip);
        els.matColors.appendChild(button);
      });
    }

    function setMatColor(colorKey) {
      var option = mattFarben().filter(function (c) { return c.color === colorKey; })[0];
      if (!option) return;
      state.matColor = colorKey;

      var buttons = els.matColors.querySelectorAll('[data-mat-color]');
      for (var i = 0; i < buttons.length; i++) {
        var isActive = buttons[i].dataset.matColor === colorKey;
        buttons[i].classList.toggle('sfc-swatch--active', isActive);
        buttons[i].setAttribute('aria-checked', isActive ? 'true' : 'false');
      }
      if (els.matValue) els.matValue.textContent = option.displayName;
      renderPreview();
    }

    /* ---------------- Preis ---------------- */

    function updateSummary() {
      var g = geometry();
      if (!g) return;

      /* Ohne Mengenwahl ist der Stueckpreis der Gesamtpreis — oben und unten
         steht damit dieselbe Zahl in derselben Schreibweise. */
      var preis = aktuellerPreis();
      var ohnePp = istOhnePp(g);
      var format = formatCm(g.aussenB) + ' × ' + formatCm(g.aussenH) + ' cm';
      var motiv = formatCm(g.ausschnittB) + ' × ' + formatCm(g.ausschnittH) + ' cm';

      if (els.price) els.price.textContent = formatMoney(preis);
      if (els.priceTop) els.priceTop.textContent = formatMoney(preis);
      if (els.footerDetail) {
        var aussen = aussenmass(g);
        /* Benannte Zeilen statt einer Punktkette. Der erste Wert trug vorher
           keinen Namen, obwohl er das Format meint. */
        var zeilen = [['Format', format]];
        zeilen.push([
          g.anzahl > 1 ? ('Motive (' + g.anzahl + '×)') : 'Motiv',
          g.anzahl > 1 ? ('je ' + motiv) : motiv
        ]);
        zeilen.push(['Außenmaß', formatCm(aussen.breite) + ' × ' + formatCm(aussen.hoehe) + ' cm']);

        els.footerDetail.innerHTML = '';
        zeilen.forEach(function (zeile) {
          var name = document.createElement('dt');
          name.className = 'sfc-masse__name';
          name.textContent = zeile[0];
          var wert = document.createElement('dd');
          wert.className = 'sfc-masse__wert';
          wert.textContent = zeile[1];
          els.footerDetail.appendChild(name);
          els.footerDetail.appendChild(wert);
        });
      }

      /* Ohne Passepartout erklaert der Text etwas, das gerade nicht zutrifft. */
      if (els.ppErklaerung) els.ppErklaerung.hidden = ohnePp;
      if (els.ppMotivsatz) {
        if (ohnePp) {
          els.ppMotivsatz.textContent = '';
        } else if (g.anzahl > 1) {
          els.ppMotivsatz.textContent = 'Bei ' + format + ' bleiben ' + g.anzahl +
            ' Motive von je ' + motiv + '.';
        } else {
          els.ppMotivsatz.textContent = 'Bei ' + format + ' bleibt ein Motiv von ' + motiv + '.';
        }
      }
      if (els.atcSub) {
        els.atcSub.style.display = preis >= 15000 ? '' : 'none';
      }

      /* Der Knopf sagt, was als naechstes zu tun ist, statt stumm abzulehnen —
         und bei mehreren Ausschnitten, wie viele Bilder noch fehlen.

         Die fixierte Leiste bekommt die kurze Fassung: ihr Knopf schrumpft
         nicht (flex-shrink: 0), ein langer Text draengt dort das Format aus
         der Zeile. */
      var knopfText, knopfKurz;
      if (alleBilderDa()) {
        knopfText = knopfKurz = texte.atcNormal || 'In den Warenkorb';
      } else if (state.slots.length > 1) {
        var fehlen = state.slots.length - state.slots.filter(function (x) { return !!x.original; }).length;
        knopfText = fehlen === state.slots.length
          ? (state.slots.length + ' Bilder hochladen')
          : ('Noch ' + fehlen + (fehlen === 1 ? ' Bild' : ' Bilder') + ' hochladen');
        knopfKurz = fehlen === 1 ? '1 Bild fehlt' : (fehlen + ' Bilder fehlen');
      } else {
        knopfText = texte.atcOhneBild || 'Lade zuerst dein Bild hoch';
        knopfKurz = 'Bild hochladen';
      }

      /* Die fixierte Kaufleiste zeigt dasselbe wie der Kaufblock. */
      if (els.mobilbarPreis) els.mobilbarPreis.textContent = formatMoney(preis);
      if (els.mobilbarFormat) els.mobilbarFormat.textContent = format;
      if (els.mobilbarKnopf) els.mobilbarKnopf.textContent = knopfKurz;
      if (els.atcText) els.atcText.textContent = knopfText;

      updateQualityHint();
    }

    function updateDelivery() {
      if (!els.delivery) return;
      var config = formatConfig.delivery || {};
      var now = new Date();
      var from = addWorkdays(now, config.min || 5);
      var to = addWorkdays(now, config.max || 8);
      els.delivery.textContent = (config.prefix || 'Lieferung ca.') + ' ' +
        formatDateShort(from) + ' – ' + formatDateShort(to);
    }

    /* ---------------- Upload ---------------- */

    function showUploadError(message) {
      if (!els.uploadError) return;
      els.uploadError.textContent = message;
      els.uploadError.hidden = false;
    }

    function clearUploadError() {
      if (els.uploadError) els.uploadError.hidden = true;
    }

    /**
     * Nimmt eine Datei fuer EINEN Slot an.
     *
     * @param {File} file
     * @param {number} index  Slot, fuer den die Datei gewaehlt wurde
     */
    function handleFile(file, index) {
      if (!file) return;
      var i = index == null ? state.aktiverSlot : index;
      var s = state.slots[i];
      if (!s) return;
      clearUploadError();

      // Bei Validierungsfehlern das Feld leeren, sonst feuert die erneute Auswahl
      // derselben (korrigierten) Datei kein change-Event mehr.
      if (ALLOWED_TYPES.indexOf(file.type) === -1) {
        showUploadError('Nur JPG, PNG oder WebP.');
        if (els.fileInput) els.fileInput.value = '';
        return;
      }
      if (file.size > MAX_UPLOAD_BYTES) {
        showUploadError('Datei zu groß (max. 25 MB).');
        if (els.fileInput) els.fileInput.value = '';
        return;
      }

      // Ab hier gilt das bisherige Bild DIESES SLOTS als ungueltig — synchron,
      // damit ein sofortiger Warenkorb-Klick nicht den Zuschnitt des
      // Vorgaengers verschickt. Die alten Blob-URLs werden aber erst
      // freigegeben, wenn das neue Bild wirklich dekodierbar ist (sonst bleibt
      // bei einer defekten Datei eine widerrufene URL im State zurueck).
      var previous = {
        original: s.original,
        croppedBlobUrl: s.croppedBlobUrl
      };
      s.cropToken++;
      s.cropPromise = null;
      s.crop = null;
      s.croppedBlob = null;
      s.croppedBlobUrl = null;
      s.croppedRemoteUrl = null;
      s.croppedDirty = true;
      s.originalRemoteUrl = null;
      s.originalUploadPromise = null;

      var blobUrl = URL.createObjectURL(file);
      var probe = new Image();

      probe.onload = function () {
        if (previous.original && previous.original.blobUrl) URL.revokeObjectURL(previous.original.blobUrl);
        if (previous.croppedBlobUrl) URL.revokeObjectURL(previous.croppedBlobUrl);

        s.original = {
          blobUrl: blobUrl,
          width: probe.naturalWidth,
          height: probe.naturalHeight,
          type: file.type,
          name: file.name
        };

        /* Ausrichtung automatisch aus dem Bild ableiten, solange der Kunde
           nicht selbst gewaehlt hat — aber nur nach dem ERSTEN Bild. Sonst
           dreht das vierte Foto die Rahmung unter den drei vorherigen weg. */
        var ersteBild = state.slots.filter(function (x) { return !!x.original; }).length === 1;
        if (ersteBild && formatConfig.allowOrientationSwitch && !state.orientationTouchedByUser) {
          var quer = probe.naturalWidth > probe.naturalHeight;
          if (state.wunschQuer !== quer) {
            state.wunschQuer = quer;
            uebernehmeFormat();
            if (state.slots.length > 1) renderSlots();
            renderFormatKacheln();
            renderPpWahl();
          }
          state.orientationInitialised = true;
          syncOrientationUi();
          if (els.orientationAuto) els.orientationAuto.hidden = false;
        }

        s.crop = maxCenteredCrop(probe.naturalWidth, probe.naturalHeight, geo ? geo.ratio : 1);
        zeigeSlot(i);

        applyCrop(i);
        updateStepSubtitles();
        markiereBeispielAuswahl();
        sichereZustand();
        updateSummary();

        /* Erst wenn alle Ausschnitte ein Bild haben, geht es weiter. Solange
           noch Ablagen leer sind, bleibt der Upload-Schritt offen — die
           naechste leere Ablage ist die naechste Aufgabe. */
        if (alleBilderDa()) {
          var nextStep = $('sfc-step-orientation') || $('sfc-step-leiste');
          if (nextStep) openStep(nextStep);
        }

        /* Und direkt in den Ausschnitt: der zentrierte Zuschnitt oben ist nur
           die Vorbelegung, die Wahl des Ausschnitts gehoert dem Kunden. Wer
           nichts aendern will, schliesst das Fenster — die Vorbelegung steht
           dann schon in der Vorschau. Gilt fuer Dateidialog und Drag & Drop
           gleichermassen, beide laufen durch handleFile(). */
        /* Mehrere Dateien auf einmal: die Dekodierungen enden in beliebiger
           Reihenfolge. Ein bereits offener Dialog darf NICHT unter dem Kunden
           den Slot wechseln — er zoege sonst weiter am alten Bild, waehrend
           die Klemmung schon gegen die Masse des neuen rechnet. */
        if (!els.crop || els.crop.hidden) openCropEditor(i);

        // Original im Hintergrund sichern (fuer Produktion / Reklamation)
        setzeSlotFortschritt(i, 0, s);
        s.originalUploadPromise = uploadToFirebase(file, 'original-' + (i + 1), function (pct) {
          setzeSlotFortschritt(i, pct, s);
        })
          .then(function (url) {
            s.originalRemoteUrl = url;
            setzeSlotFortschritt(i, null, s);
            return url;
          })
          .catch(function (err) {
            console.error('[SFC] Original-Upload fehlgeschlagen (Ausschnitt ' + (i + 1) + '):', err);
            setzeSlotFortschritt(i, null, s);
            return null;
          });
      };

      probe.onerror = function () {
        // Neue Datei ist defekt: das vorherige Bild bleibt unangetastet nutzbar.
        URL.revokeObjectURL(blobUrl);
        s.original = previous.original;
        s.croppedBlobUrl = previous.croppedBlobUrl;
        if (els.fileInput) els.fileInput.value = '';
        zeigeSlot(i);
        showUploadError('Dieses Bild konnte nicht gelesen werden. Bitte wähle eine andere Datei.');
      };

      probe.src = blobUrl;
    }

    /** Entfernt das Bild EINES Slots. Der Slot selbst bleibt stehen. */
    function removeImage(index) {
      var i = index == null ? state.aktiverSlot : index;
      var s = state.slots[i];
      if (!s) return;

      gibSlotFrei(s);
      s.cropToken++;
      s.cropPromise = null;
      s.original = null;
      s.crop = null;
      s.croppedBlobUrl = null;
      s.croppedBlob = null;
      s.croppedRemoteUrl = null;
      s.croppedDirty = true;
      s.originalRemoteUrl = null;
      s.originalUploadPromise = null;

      zeigeSlot(i);
      setzeSlotFortschritt(i, null);
      if (els.fileInput) els.fileInput.value = '';
      if (!hatBild() && els.uploadQuality) els.uploadQuality.hidden = true;
      clearUploadError();
      updateStepSubtitles();
      markiereBeispielAuswahl();
      sichereZustand();
      renderPreview();
      updateQualityHint();
      updateSummary();
    }

    /* =================================================================
     * Crop-Editor — Auswahlrahmen mit festem Seitenverhaeltnis
     * ================================================================= */

    var cropUi = {
      /** Bildmasse auf dem Bildschirm (px) */
      displayW: 0,
      displayH: 0,
      /** Auswahlbox in Bildschirm-px, relativ zur linken oberen Bildecke */
      box: { x: 0, y: 0, w: 0, h: 0 },
      ratio: 1,
      drag: null,
      lastFocus: null
    };

    /**
     * Oeffnet den Zuschnitt fuer EINEN Slot.
     * @param {number} [index] Slot; ohne Angabe der zuletzt aktive
     */
    function openCropEditor(index) {
      if (index != null) state.aktiverSlot = index;
      var s = slot();
      if (!s || !s.original || !els.crop || !geo) return;

      cropUi.ratio = geo.ratio;
      cropUi.lastFocus = document.activeElement;
      els.crop.hidden = false;
      document.body.classList.add('sfc-no-scroll');

      /* Bei mehreren Ausschnitten sagt die Ueberschrift, welcher gerade
         drankommt — sonst weiss man nach dem dritten Dialog nicht mehr,
         welches Bild man da zuschneidet. */
      var titel = els.crop.querySelector('.sfc-crop__title');
      if (titel) {
        if (!titel.dataset.standard) titel.dataset.standard = titel.textContent;
        titel.textContent = state.slots.length > 1
          ? (titel.dataset.standard + ' — Ausschnitt ' + (state.aktiverSlot + 1) + ' von ' + state.slots.length)
          : titel.dataset.standard;
      }

      els.cropImg.onload = function () {
        layoutCropImage();
        // Vorhandenen Ausschnitt uebernehmen, sonst groesstmoeglich zentriert
        var source = s.crop || maxCenteredCrop(s.original.width, s.original.height, cropUi.ratio);
        var scale = cropUi.displayW / s.original.width;
        cropUi.box = {
          x: source.x * scale,
          y: source.y * scale,
          w: source.w * scale,
          h: source.h * scale
        };
        clampBox();
        drawBox();
        if (els.cropBox) els.cropBox.focus();
      };
      els.cropImg.src = s.original.blobUrl;

      // Falls das Bild aus dem Cache kommt und onload nicht mehr feuert
      if (els.cropImg.complete && els.cropImg.naturalWidth) {
        els.cropImg.onload();
      }
    }

    function closeCropEditor() {
      if (!els.crop) return;
      els.crop.hidden = true;
      document.body.classList.remove('sfc-no-scroll');
      if (cropUi.lastFocus && typeof cropUi.lastFocus.focus === 'function') {
        cropUi.lastFocus.focus();
      }
    }

    /** Pfeiltasten verschieben die Auswahl, Plus/Minus skalieren sie. */
    function onCropKeydown(event) {
      if (!slot().original || !cropUi.displayW) return;

      var step = event.shiftKey ? 20 : 4;
      var handled = true;

      switch (event.key) {
        case 'ArrowLeft':  cropUi.box.x -= step; break;
        case 'ArrowRight': cropUi.box.x += step; break;
        case 'ArrowUp':    cropUi.box.y -= step; break;
        case 'ArrowDown':  cropUi.box.y += step; break;
        case '+':
        case '=':
          cropUi.box.x -= step / 2;
          cropUi.box.y -= step / (2 * cropUi.ratio);
          cropUi.box.w += step;
          break;
        case '-':
        case '_':
          cropUi.box.x += step / 2;
          cropUi.box.y += step / (2 * cropUi.ratio);
          cropUi.box.w -= step;
          break;
        default:
          handled = false;
      }

      if (!handled) return;
      event.preventDefault();
      clampBox();
      drawBox();
    }

    /** Passt das Bild in die Stage ein (object-fit: contain nachgebaut, damit wir exakte Masse kennen). */
    function layoutCropImage() {
      // getBoundingClientRect liefert die BORDER-Box inklusive Padding. Wuerden wir damit
      // rechnen, waere der Wrapper breiter als der verfuegbare Platz, der Browser wuerde
      // ihn als Flex-Item still zusammenstauchen — und alle Rueckrechnungen von
      // Bildschirm- auf Originalkoordinaten waeren um diesen Faktor daneben.
      var stageStyle = window.getComputedStyle(els.cropStage);
      var stageRect = els.cropStage.getBoundingClientRect();
      var availableW = stageRect.width
        - parseFloat(stageStyle.paddingLeft || 0)
        - parseFloat(stageStyle.paddingRight || 0);
      var availableH = stageRect.height
        - parseFloat(stageStyle.paddingTop || 0)
        - parseFloat(stageStyle.paddingBottom || 0);

      var stage = { width: Math.max(1, availableW), height: Math.max(1, availableH) };
      var naturalRatio = slot().original.width / slot().original.height;

      var width = stage.width;
      var height = width / naturalRatio;
      if (height > stage.height) {
        height = stage.height;
        width = height * naturalRatio;
      }

      cropUi.displayW = width;
      cropUi.displayH = height;
      els.cropImgWrap.style.width = width + 'px';
      els.cropImgWrap.style.height = height + 'px';
    }

    /** Haelt die Box im Bild, im richtigen Verhaeltnis und ueber der Mindestgroesse. */
    function clampBox() {
      var box = cropUi.box;
      var maxBox = maxCenteredCrop(cropUi.displayW, cropUi.displayH, cropUi.ratio);

      // Bei extremen Formaten (Panorama) kann die groesstmoegliche Box schmaler als
      // MIN_CROP_PX sein. Dann gewinnt die Bildgrenze — sonst raggt die Box heraus.
      var minWidth = Math.min(MIN_CROP_PX, maxBox.w);

      box.w = clamp(box.w, minWidth, maxBox.w);
      box.h = box.w / cropUi.ratio;

      if (box.h > cropUi.displayH) {
        box.h = cropUi.displayH;
        box.w = box.h * cropUi.ratio;
      }

      box.x = clamp(box.x, 0, Math.max(0, cropUi.displayW - box.w));
      box.y = clamp(box.y, 0, Math.max(0, cropUi.displayH - box.h));
    }

    function drawBox() {
      var box = cropUi.box;
      els.cropBox.style.left = box.x + 'px';
      els.cropBox.style.top = box.y + 'px';
      els.cropBox.style.width = box.w + 'px';
      els.cropBox.style.height = box.h + 'px';

      // Abdunklung ausserhalb der Auswahl
      els.cropShade.style.clipPath =
        'polygon(0 0, 100% 0, 100% 100%, 0 100%, 0 0,' +
        ' ' + px(box.x) + ' ' + px(box.y) + ',' +
        ' ' + px(box.x) + ' ' + px(box.y + box.h) + ',' +
        ' ' + px(box.x + box.w) + ' ' + px(box.y + box.h) + ',' +
        ' ' + px(box.x + box.w) + ' ' + px(box.y) + ',' +
        ' ' + px(box.x) + ' ' + px(box.y) + ')';

      updateCropMeta();
    }

    function px(value) { return value.toFixed(2) + 'px'; }

    function updateCropMeta() {
      if (!els.cropRatio || !geo) return;
      els.cropRatio.textContent = 'Motiv ' + formatCm(geo.ausschnittB) + ' × ' + formatCm(geo.ausschnittH) + ' cm';

      if (els.cropWarn) {
        var scale = slot().original.width / cropUi.displayW;
        var sourcePx = cropUi.box.w * scale;
        var dpi = sourcePx / (geo.ausschnittB / 2.54);
        if (dpi < GOOD_PRINT_DPI) {
          els.cropWarn.textContent = 'ca. ' + Math.round(dpi) + ' dpi — für diese Größe knapp';
          els.cropWarn.hidden = false;
          els.cropWarn.classList.toggle('sfc-crop__warn--low', dpi < LOW_PRINT_DPI);
        } else {
          els.cropWarn.hidden = true;
        }
      }
    }

    function onCropStart(event) {
      if (!slot().original) return;
      var handle = event.target.closest ? event.target.closest('[data-handle]') : null;
      var pos = pointerPos(event, els.cropImgWrap);
      var box = cropUi.box;

      var insideBox = pos.x >= box.x && pos.x <= box.x + box.w &&
                      pos.y >= box.y && pos.y <= box.y + box.h;

      if (!handle && !insideBox) return;
      event.preventDefault();

      cropUi.drag = {
        handle: handle ? handle.dataset.handle : null,
        startX: pos.x,
        startY: pos.y,
        origin: { x: box.x, y: box.y, w: box.w, h: box.h }
      };
      els.cropBox.classList.add('sfc-crop__box--active');
    }

    function onCropMove(event) {
      if (!cropUi.drag) return;
      event.preventDefault();

      var pos = pointerPos(event, els.cropImgWrap);
      var drag = cropUi.drag;
      var origin = drag.origin;
      var dx = pos.x - drag.startX;
      var dy = pos.y - drag.startY;

      if (!drag.handle) {
        // Verschieben
        cropUi.box.x = origin.x + dx;
        cropUi.box.y = origin.y + dy;
        cropUi.box.w = origin.w;
        cropUi.box.h = origin.h;
      } else {
        // Skalieren — Seitenverhaeltnis bleibt fix, der gegenueberliegende Eckpunkt bleibt stehen.
        var anchorX = drag.handle.indexOf('l') !== -1 ? origin.x + origin.w : origin.x;
        var anchorY = drag.handle.indexOf('t') !== -1 ? origin.y + origin.h : origin.y;

        var signX = drag.handle.indexOf('l') !== -1 ? -1 : 1;
        var signY = drag.handle.indexOf('t') !== -1 ? -1 : 1;

        // Breite aus beiden Achsen mitteln, damit die Diagonale sich natuerlich anfuehlt
        var widthFromX = origin.w + signX * dx;
        var widthFromY = (origin.h + signY * dy) * cropUi.ratio;
        var newWidth = (widthFromX + widthFromY) / 2;

        // Maximale Breite, damit die Box am Anker verankert im Bild bleibt
        var maxWidth = signX > 0 ? cropUi.displayW - anchorX : anchorX;
        var maxHeight = signY > 0 ? cropUi.displayH - anchorY : anchorY;
        var ceiling = Math.min(maxWidth, maxHeight * cropUi.ratio);
        newWidth = Math.min(newWidth, ceiling);
        newWidth = Math.max(newWidth, Math.min(MIN_CROP_PX, ceiling));

        var newHeight = newWidth / cropUi.ratio;

        cropUi.box.w = newWidth;
        cropUi.box.h = newHeight;
        cropUi.box.x = signX > 0 ? anchorX : anchorX - newWidth;
        cropUi.box.y = signY > 0 ? anchorY : anchorY - newHeight;
      }

      clampBox();
      drawBox();
    }

    function onCropEnd() {
      if (!cropUi.drag) return;
      cropUi.drag = null;
      els.cropBox.classList.remove('sfc-crop__box--active');
    }

    function confirmCrop() {
      var i = state.aktiverSlot;
      var s = state.slots[i];
      if (!s || !s.original) { closeCropEditor(); return; }

      var scale = s.original.width / cropUi.displayW;
      s.crop = {
        x: Math.round(cropUi.box.x * scale),
        y: Math.round(cropUi.box.y * scale),
        w: Math.round(cropUi.box.w * scale),
        h: Math.round(cropUi.box.h * scale)
      };
      // Rundungsfehler abfangen
      s.crop.w = Math.min(s.crop.w, s.original.width - s.crop.x);
      s.crop.h = Math.min(s.crop.h, s.original.height - s.crop.y);

      closeCropEditor();
      applyCrop(i);

      /* Der geaenderte Ausschnitt gehoert in den Sitzungsspeicher — sonst
         landet er dort erst beim naechsten Format- oder Leistenwechsel, und
         ein Neuladen wirft ihn auf die Vorbelegung zurueck. */
      sichereZustand();
    }

    function resetCrop() {
      cropUi.box = maxCenteredCrop(cropUi.displayW, cropUi.displayH, cropUi.ratio);
      clampBox();
      drawBox();
    }

    /* =================================================================
     * In den Warenkorb
     * ================================================================= */

    /**
     * Liefert die Firebase-URL des zugeschnittenen Bildes.
     * Wartet dabei auf einen ggf. noch laufenden Zuschnitt, damit nie eine veraltete
     * URL zurueckkommt, und startet neu, falls waehrend des Uploads erneut gecroppt wurde.
     */
    function ensureCroppedUpload(index) {
      var i = index == null ? 0 : index;
      var s = state.slots[i];
      if (!s) return Promise.reject(new Error('Ausschnitt ' + (i + 1) + ' fehlt.'));

      return Promise.resolve(s.cropPromise).then(function () {
        if (s.croppedRemoteUrl && !s.croppedDirty) {
          return s.croppedRemoteUrl;
        }
        if (!s.croppedBlob) {
          throw new Error(state.slots.length > 1
            ? ('Bild ' + (i + 1) + ' wird noch verarbeitet. Bitte versuche es gleich noch einmal.')
            : 'Dein Bild wird noch verarbeitet. Bitte versuche es gleich noch einmal.');
        }

        var blob = s.croppedBlob;
        var token = s.cropToken;

        /* Der Dateiname traegt die Ausschnittnummer: in der Werkstatt liegen
           sonst vier "processed-*.jpg" nebeneinander, ohne erkennbar zu sein,
           welches in welches Fenster gehoert. */
        return uploadToFirebase(blob, 'processed-' + (i + 1)).then(function (url) {
          // Waehrend des Uploads wurde erneut zugeschnitten -> Ergebnis verwerfen, neu versuchen.
          if (token !== s.cropToken) return ensureCroppedUpload(i);
          s.croppedRemoteUrl = url;
          s.croppedDirty = false;
          return url;
        });
      });
    }

    /** Alle Ausschnitte hochladen — die Reihenfolge des Ergebnisses ist die Zuordnung. */
    function ensureAlleUploads() {
      return Promise.all(state.slots.map(function (_, i) { return ensureCroppedUpload(i); }));
    }

    function setAtcBusy(busy) {
      els.atc.disabled = busy;
      if (els.atcText) els.atcText.style.display = busy ? 'none' : '';
      if (els.atcSub) els.atcSub.style.display = busy ? 'none' : '';
      if (els.atcLoading) els.atcLoading.hidden = !busy;
    }

    function addToCart() {
      if (els.atcError) els.atcError.hidden = true;

      /* Ohne vollstaendige Bilder ist der Knopf keine Sperre, sondern der Weg
         dorthin: er zeigt, welche Ablage noch leer ist, und oeffnet direkt den
         Dateidialog. Die Vorschau zeigt zu diesem Zeitpunkt ein Beispielbild,
         eine stumme Ablehnung waere doppelt verwirrend. */
      var leer = ersterLeererSlot();
      if (leer !== -1) {
        var ablage = state.slots[leer].el;
        if (ablage) {
          ablage.classList.add('sfc-upload--missing');
          ablage.scrollIntoView({ behavior: 'smooth', block: 'center' });
          window.setTimeout(function () { ablage.classList.remove('sfc-upload--missing'); }, 2000);
        }
        state.aktiverSlot = leer;
        if (els.fileInput) els.fileInput.click();
        return;
      }

      if (!aktuelleVariante()) {
        if (els.atcError) {
          els.atcError.textContent = 'Dieses Produkt ist derzeit nicht bestellbar.';
          els.atcError.hidden = false;
        }
        return;
      }

      setAtcBusy(true);

      var g = geometry();
      var matColor = mattFarben().filter(function (c) { return c.color === state.matColor; })[0] || SFC_MAT_COLORS[0];
      var ohnePp = istOhnePp(g);

      // Kurz auf die Original-Uploads warten, damit _originalImageUrl nicht still
      // fehlt, wenn der Kunde schneller klickt als die Leitung hergibt. Aber nur
      // kurz: bei einem 20-MB-Foto ueber Mobilfunk darf der Kauf nicht 40 Sekunden
      // blockieren. Das Druckfile ist ohnehin der Zuschnitt; das Original ist nur
      // Rueckfallebene fuer die Produktion.
      var originaleMitTimeout = Promise.race([
        Promise.all(state.slots.map(function (s) {
          return Promise.resolve(s.originalUploadPromise).catch(function () { return null; });
        })),
        new Promise(function (resolve) { window.setTimeout(function () { resolve([]); }, 10000); })
      ]);

      Promise.all([ensureAlleUploads(), originaleMitTimeout])
        .then(function (uploads) {
          var bildUrls = uploads[0];

          /* Die Raender sind ringsum gleich; nur Steg und die beiden
             Randmasse unterscheiden sich. */
          var matWidthLabel = formatCm(g.randOu) + ' oben und unten, ' +
            formatCm(g.randLr) + ' links und rechts' +
            (g.anzahl > 1 ? (' · Steg ' + formatCm(g.steg) + ' cm') : ' (cm)');

          /* Sichtbare Keys bleiben sparsam: assets/cart-drawer.js kopiert jeden
             davon auf verknuepfte Upsell-Positionen, vier weitere Zeilen wuerden
             dort zu acht. Die Produktionswahrheit steht in den _-Keys. */
          var properties = {
            'Format': formatCm(g.aussenB) + ' × ' + formatCm(g.aussenH) + ' cm',
            'Ausrichtung': g.aussenH >= g.aussenB ? 'Hochformat' : 'Querformat',
            'Bildgröße': (g.anzahl > 1 ? 'je ' : '') +
              formatCm(g.ausschnittB) + ' × ' + formatCm(g.ausschnittH) + ' cm',
            'Passepartout-Farbe': ohnePp ? 'Ohne Passepartout' : matColor.displayName,
            'Passepartout-Breite': ohnePp ? 'Ohne Passepartout' : matWidthLabel
          };

          if (!ohnePp && g.anzahl > 1) {
            properties['Ausschnitte'] = g.anzahl + ' (' +
              g.zeilen + ' ' + (g.zeilen === 1 ? 'Reihe' : 'Reihen') + ' × ' +
              g.spalten + ' ' + (g.spalten === 1 ? 'Spalte' : 'Spalten') + ')';
          }

          /* Sagt der Werkstatt, ob die Aufloesung fuer das gewaehlte Format
             reicht — oder ob der Kunde die Warnung weggeklickt hat. Bei
             mehreren Bildern zaehlt das schwaechste. */
          var dpiJetzt = dpiFuer(null);
          properties['_aufloesung_ok'] = (dpiJetzt === null || dpiJetzt >= LOW_PRINT_DPI) ? 'true' : 'false';

          /* Erstes Bild bleibt auf den bisherigen Keys: Bestellexporte und
             Auswertungen der Werkstatt lesen sie seit jeher, und bei einem
             Ausschnitt — dem haeufigsten Fall — bleibt damit alles wie es war. */
          properties['_imageUrl'] = bildUrls[0];
          if (state.slots[0].originalRemoteUrl) {
            properties['_originalImageUrl'] = state.slots[0].originalRemoteUrl;
          }
          if (state.slots[0].crop) {
            properties['_cropRect'] = JSON.stringify({
              x: state.slots[0].crop.x, y: state.slots[0].crop.y,
              w: state.slots[0].crop.w, h: state.slots[0].crop.h,
              sourceWidth: state.slots[0].original.width,
              sourceHeight: state.slots[0].original.height
            });
          }

          /* Die Schnittmasse des Blattes, so wie es die Werkstatt braucht.
             Alles in cm, Nullpunkt links oben an der Blattaussenkante. */
          if (!ohnePp) {
            properties['_pp_masse'] = JSON.stringify({
              aussen: { b: g.aussenB, h: g.aussenH },
              anzahl_ausschnitte: g.anzahl,
              raster: { spalten: g.spalten, zeilen: g.zeilen },
              ausschnitt: { b: g.ausschnittB, h: g.ausschnittH },
              steg: g.steg,
              rand_lr: g.randLr,
              rand_ou: g.randOu,
              /* Wie die Werkstatt das Blatt haengt. Nicht das interne
                 Drehflag: gemeint ist die Lage, die der Kunde sieht. */
              lage: g.aussenH >= g.aussenB ? 'hoch' : 'quer'
            });
          }

          /* Ein Eintrag je Ausschnitt, in Leserichtung nummeriert — damit ist
             eindeutig, welches Bild in welches Fenster gehoert, ohne dass
             jemand eine Reihenfolge erraten muss. */
          if (g.anzahl > 1) {
            properties['_ausschnitte'] = JSON.stringify(g.fenster.map(function (f, idx) {
              var s = state.slots[idx] || {};
              var eintrag = {
                nr: idx + 1,
                spalte: f.spalte, zeile: f.zeile,
                x: f.x, y: f.y, b: f.b, h: f.h,
                bildUrl: bildUrls[idx] || null
              };
              if (s.originalRemoteUrl) eintrag.originalUrl = s.originalRemoteUrl;
              if (s.crop && s.original) {
                eintrag.crop = {
                  x: s.crop.x, y: s.crop.y, w: s.crop.w, h: s.crop.h,
                  sourceWidth: s.original.width, sourceHeight: s.original.height
                };
              }
              return eintrag;
            }));
          }

          // ACHTUNG — Reihenfolge der Keys ist bindend:
          // sections/main-cart-items.liquid:123-127 parst diesen String per Liquid-Split
          // und schneidet `"mat_color":` bis `,"mat_width"` heraus. Steht dazwischen ein
          // weiterer Key, landet Müll im data-mat-color-Attribut des Warenkorbs.
          // `mat_color_url` gehoert deshalb ans Ende (wie in frame-configurator.js:5210),
          // und `cutouts` dazwischen — hinter individual_sizes, vor mat_color_url.
          //
          // passepartout_type bleibt 'einfach': cart-svg-renderer-simple.js:505-508
          // kennt nur eine feste Werteliste und faellt bei allem anderen stumm auf
          // "gar kein Passepartout" zurueck. Die Ausschnitte reist stattdessen
          // `cutouts` mit.
          var renderDaten = {
            customer_image_url: bildUrls[0],
            frame_product_id: productData.productId,
            frame_name: productData.title,
            mat_color: state.matColor,
            mat_width: 'individual',
            // cart-svg-renderer-simple.js:521 erwartet exakt diesen Key-Namen
            individual_sizes: ohnePp
              ? { top: 0, right: 0, bottom: 0, left: 0 }
              : { top: g.randOu, right: g.randLr, bottom: g.randOu, left: g.randLr },
            rotation: 0,
            /* Mit cutouts meint dimensions das Blattaussenmass, ohne das
               Motivmass — so rechnet generateFramePreviewSvg. */
            dimensions: ohnePp
              ? { width: g.ausschnittB, height: g.ausschnittH }
              : { width: g.aussenB, height: g.aussenH },
            frame_texture_lr: productData.frameImageLR,
            frame_texture_tb: productData.frameImageTB,
            frame_width_mm: productData.frameBreiteMM,
            passepartout_type: ohnePp ? 'ohne' : 'einfach'
          };

          if (!ohnePp) {
            renderDaten.cutouts = g.fenster.map(function (f, idx) {
              return { x: f.x, y: f.y, w: f.b, h: f.h, imageUrl: bildUrls[idx] || bildUrls[0] };
            });
          }

          renderDaten.mat_color_url = {
            url: matColor.imageUrl,
            color_key: matColor.color,
            display_name: matColor.displayName
          };

          properties['_SVG-Render-Data'] = JSON.stringify(renderDaten);

          /* Shopify kappt Property-Werte bei 5000 Zeichen. Mit vier Bildern
             sind es je Wert rund 1500 — es reicht, aber still abgeschnittene
             Auftragsdaten waeren der teuerste denkbare Fehler, deshalb wird es
             geprueft statt angenommen. */
          Object.keys(properties).forEach(function (key) {
            if (String(properties[key]).length > 5000) {
              console.error('[SFC] Property "' + key + '" ist laenger als 5000 Zeichen und wird ' +
                'von Shopify abgeschnitten. Bestelldaten koennen unvollstaendig sein.');
            }
          });

          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

          return fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              // Eine Rahmung ist ein Einzelstueck — der Konfigurator legt immer
              // genau eine in den Warenkorb, geaendert wird das dort.
              items: [{ id: aktuelleVariante().id, quantity: 1, properties: properties }]
            })
          });
        })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) {
              throw new Error(err.description || err.message || 'Fehler beim Hinzufügen');
            });
          }
          return response.json();
        })
        .then(function (data) {
          setAtcBusy(false);
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'standard-frame-configurator',
              productVariantId: aktuelleVariante().id,
              cartData: data
            });
          }

          // Gleiches Muster wie im grossen Konfigurator: <cart-drawer> hat kein open(),
          // sondern renderContents() aus dem Theme (global.js).
          var miniCart = document.querySelector('mini-cart') || document.querySelector('cart-drawer');
          if (miniCart && miniCart.renderContents) {
            fetch(window.location.pathname + '?sections=mini-cart,cart-drawer,cart-icon-bubble')
              .then(function (r) { return r.json(); })
              .then(function (sections) { miniCart.renderContents({ sections: sections }); })
              .catch(function () { window.location.href = root + 'cart'; });
          } else {
            window.location.href = root + 'cart';
          }
        })
        .catch(function (err) {
          console.error('[SFC] Warenkorb-Fehler:', err);
          setAtcBusy(false);
          if (els.atcError) {
            els.atcError.textContent = err.message || 'Es gab ein Problem. Bitte versuche es erneut.';
            els.atcError.hidden = false;
          }
        });
    }

    /* =================================================================
     * Event-Bindung
     * ================================================================= */

    /* Die Ablagen werden per JS gebaut und wechseln mit der Ausschnittzahl —
       die Klicks haengen deshalb am Container und nicht an den Knoepfen selbst.
       Ein einzelnes Dateifeld bedient alle Slots; welcher gemeint ist, merkt
       sich state.aktiverSlot zwischen Klick und change-Ereignis. */
    if (els.uploads) {
      els.uploads.addEventListener('click', function (event) {
        var ablage = event.target.closest('[data-slot]');
        if (!ablage) return;
        var index = parseInt(ablage.dataset.slot, 10) || 0;

        if (event.target.closest('[data-rolle="entfernen"]')) {
          removeImage(index);
          return;
        }
        if (event.target.closest('[data-rolle="zuschneiden"]')) {
          openCropEditor(index);
          return;
        }
        if (event.target.closest('[data-rolle="knopf"]') ||
            event.target.closest('[data-rolle="wechseln"]')) {
          state.aktiverSlot = index;
          if (els.fileInput) els.fileInput.click();
        }
      });

      /* Drag & Drop je Ablage: das Bild landet dort, wo es fallen gelassen
         wird. Faellt es neben die Ablagen, nimmt es der erste leere Slot. */
      ['dragenter', 'dragover'].forEach(function (type) {
        els.uploads.addEventListener(type, function (event) {
          event.preventDefault();
          var ablage = event.target.closest('[data-slot]');
          state.slots.forEach(function (x) {
            if (x.el) x.el.classList.toggle('sfc-upload--over', x.el === ablage);
          });
        });
      });
      ['dragleave', 'drop'].forEach(function (type) {
        els.uploads.addEventListener(type, function (event) {
          event.preventDefault();
          state.slots.forEach(function (x) {
            if (x.el) x.el.classList.remove('sfc-upload--over');
          });
        });
      });
      els.uploads.addEventListener('drop', function (event) {
        var dateien = (event.dataTransfer && event.dataTransfer.files) || [];
        if (!dateien.length) return;

        var ablage = event.target.closest('[data-slot]');
        var start = ablage ? (parseInt(ablage.dataset.slot, 10) || 0) : Math.max(0, ersterLeererSlot());

        /* Mehrere Dateien auf einmal fuellen der Reihe nach die folgenden
           Ablagen — wer vier Bilder hat, zieht sie in einem Rutsch herein. */
        for (var d = 0; d < dateien.length && start + d < state.slots.length; d++) {
          handleFile(dateien[d], start + d);
        }
      });
    }

    if (els.leisteChips) {
      els.leisteChips.addEventListener('click', function (event) {
        var chip = event.target.closest('[data-chip]');
        if (!chip) return;
        state.leisteFilter = chip.getAttribute('data-chip');
        renderChips();
        renderLeisten();
      });
    }

    if (els.leisten) {
      els.leisten.addEventListener('click', function (event) {
        var knopf = event.target.closest('[data-leiste]');
        if (!knopf) return;
        wechsleLeiste(knopf.getAttribute('data-leiste'), true);
      });
    }

    if (els.formatKacheln) {
      els.formatKacheln.addEventListener('click', function (event) {
        var knopf = event.target.closest('[data-format]');
        if (!knopf) return;
        if (knopf.disabled) return;
        var key = knopf.getAttribute('data-format');
        if (key === state.groesseKey) return;
        wechsle(key, null, true);
      });
    }

    if (els.ppWahl) {
      els.ppWahl.addEventListener('click', function (event) {
        var knopf = event.target.closest('[data-pp]');
        if (!knopf) return;
        var wert = knopf.getAttribute('data-pp');
        if (wert === state.pp) return;
        wechsle(null, wert, true);
      });
    }

    if (els.beispiele) {
      els.beispiele.addEventListener('click', function (event) {
        var knopf = event.target.closest('[data-beispiel-index]');
        if (!knopf) return;
        setzeBeispiel(parseInt(knopf.getAttribute('data-beispiel-index'), 10));
      });
    }
    if (els.fileInput) {
      els.fileInput.addEventListener('change', function (event) {
        var dateien = event.target.files || [];
        if (!dateien.length) return;

        /* Mehrfachauswahl fuellt ab dem angeklickten Slot weiter — sonst
           muesste man den Dateidialog viermal oeffnen. */
        for (var d = 0; d < dateien.length && state.aktiverSlot + d < state.slots.length; d++) {
          handleFile(dateien[d], state.aktiverSlot + d);
        }

        /* Feld leeren, sonst loest dieselbe Datei fuer einen zweiten Ausschnitt
           kein change-Ereignis mehr aus — wer zweimal dasselbe Motiv rahmen
           will, klickt dann ins Leere. */
        event.target.value = '';
      });
    }

    if (els.orientationOptions) {
      els.orientationOptions.addEventListener('click', function (event) {
        var button = event.target.closest('[data-orientation]');
        if (!button) return;
        setOrientation(button.dataset.orientation, true);
        if (els.orientationAuto) els.orientationAuto.hidden = true;
      });
    }

    if (els.matColors) {
      els.matColors.addEventListener('click', function (event) {
        var button = event.target.closest('[data-mat-color]');
        if (!button) return;
        setMatColor(button.dataset.matColor);
      });
    }

    if (els.cropClose) els.cropClose.addEventListener('click', closeCropEditor);
    if (els.cropCancel) els.cropCancel.addEventListener('click', closeCropEditor);
    if (els.cropBackdrop) els.cropBackdrop.addEventListener('click', closeCropEditor);
    if (els.cropReset) els.cropReset.addEventListener('click', resetCrop);
    if (els.cropConfirm) els.cropConfirm.addEventListener('click', confirmCrop);

    if (els.cropImgWrap) {
      els.cropImgWrap.addEventListener('mousedown', onCropStart);
      els.cropImgWrap.addEventListener('touchstart', onCropStart, { passive: false });
    }
    if (els.cropBox) els.cropBox.addEventListener('keydown', onCropKeydown);
    document.addEventListener('mousemove', onCropMove);
    document.addEventListener('touchmove', onCropMove, { passive: false });
    document.addEventListener('mouseup', onCropEnd);
    document.addEventListener('touchend', onCropEnd);
    document.addEventListener('touchcancel', onCropEnd);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && els.crop && !els.crop.hidden) closeCropEditor();
    });

    window.addEventListener('resize', function () {
      applyHeaderHeight();
      if (els.crop && !els.crop.hidden && slot().original) {
        var previous = { w: cropUi.displayW };
        layoutCropImage();
        if (previous.w > 0) {
          var factor = cropUi.displayW / previous.w;
          cropUi.box.x *= factor;
          cropUi.box.y *= factor;
          cropUi.box.w *= factor;
          cropUi.box.h *= factor;
        }
        clampBox();
        drawBox();
      }
    });

    if (els.atc) els.atc.addEventListener('click', addToCart);
    if (els.mobilbarKnopf) els.mobilbarKnopf.addEventListener('click', addToCart);

    /* Die Leiste erscheint, sobald der eigentliche Kaufblock nicht mehr zu
       sehen ist — sonst staenden zwei Kaufknoepfe uebereinander.
       IntersectionObserver statt scroll-Handler: kein Listener auf document,
       der bei jedem shopify:section:load ein zweites Mal haengen bliebe. */
    if (els.mobilbar && els.footer && 'IntersectionObserver' in window) {
      var beobachter = new IntersectionObserver(function (eintraege) {
        var sichtbar = eintraege[0] && eintraege[0].isIntersecting;
        els.mobilbar.hidden = sichtbar;
      }, { rootMargin: '0px 0px -20% 0px' });
      beobachter.observe(els.footer);
    }

    // Galerie: Streifen, Punkte, Pfeile
    if (els.slider) {
      var galerieTimer = 0;
      els.slider.addEventListener('scroll', function () {
        window.clearTimeout(galerieTimer);
        galerieTimer = window.setTimeout(function () {
          galerieZiel = galerieIndex();
          markiereSlide(galerieZiel);
        }, 50);
      }, { passive: true });
      markiereSlide(0);
    }
    if (els.punkte) {
      els.punkte.addEventListener('click', function (event) {
        var punkt = event.target.closest('[data-punkt-index]');
        if (punkt) scrolleZuSlide(parseInt(punkt.getAttribute('data-punkt-index'), 10));
      });
    }
    if (els.galerieZurueck) els.galerieZurueck.addEventListener('click', function () { scrolleZuSlide(galerieZiel - 1); });
    if (els.galerieWeiter) els.galerieWeiter.addEventListener('click', function () { scrolleZuSlide(galerieZiel + 1); });

    /* ---------------- Start ---------------- */

    bindAccordion();
    bindTabs();
    renderMatSwatches();

    /* Startwahl aus der URL, sonst aus der Servervariante. Danach einmal
       wechsle() ohne Chronikeintrag — das setzt Geometrie, Kacheln, Massstab
       und Preis in einem Durchlauf. */
    var startWahl = wahlAusVariante(ausUrl() || startVariante);
    state.leisteHandle = productData.handle;

    /* Zustand aus der Session: er ueberlebt sowohl den Leistenwechsel als auch
       ein echtes Neuladen. Die URL hat Vorrang — wer einen Link teilt, meint
       das, was drinsteht. */
    var gespeichert = leseZustand();
    var ausAdresse = !!ausUrl();

    /* Ausschnittzahl zuerst: sie bestimmt, welche Groessen es gibt.
       Shopify liefert als erste Variante "Ohne"; deren Wert darf nur zaehlen,
       wenn er ausdruecklich in der Adresse steht. Sonst gewinnt der
       gespeicherte Zustand, sonst die einfachste Rahmung mit Passepartout —
       das Passepartout soll keine Entscheidung sein, die man erst treffen
       muss. */
    if (ppOptionVorhanden) {
      var vorauswahl = null;
      for (var pi = 0; pi < matrix.ppWerte.length; pi++) {
        if (matrix.ppWerte[pi].anzahl === 1) { vorauswahl = matrix.ppWerte[pi].wert; break; }
      }
      state.pp = (ausAdresse && startWahl.pp) ||
                 (gespeichert && gespeichert.pp) ||
                 vorauswahl ||
                 (matrix.ppWerte[0] && matrix.ppWerte[0].wert) || null;
    } else if (matrix.ppWerte.length === 1) {
      state.pp = matrix.ppWerte[0].wert;
    }

    state.groesseKey = startWahl.groesse ||
      (gespeichert && !ausAdresse ? gespeichert.groesse : null) ||
      (matrix.groessen[0] && matrix.groessen[0].key) || null;

    /* Die gespeicherte Groesse kann es zur gewaehlten Ausschnittzahl nicht
       geben — dann auf die naechste ruecken, statt mit einer Kombination zu
       starten, die keine Variante hat. */
    if (!eintragVon(state.groesseKey, ppOptionVorhanden ? state.pp : null)) {
      var startMoeglich = groessenFuer(ppOptionVorhanden ? state.pp : null);
      if (startMoeglich.length) state.groesseKey = naechsteGroesse(startMoeglich, state.groesseKey);
    }

    if (gespeichert) {
      if (gespeichert.matColor) state.matColor = gespeichert.matColor;
      if (typeof gespeichert.beispielIndex === 'number') state.beispielIndex = gespeichert.beispielIndex;
      if (gespeichert.leiste && leisteNachHandle(gespeichert.leiste)) {
        state.leisteFilter = 'Alle';
      }
      if (typeof gespeichert.quer === 'boolean') state.wunschQuer = gespeichert.quer;
      if (gespeichert.orientationTouched) state.orientationTouchedByUser = true;
    }

    /* Geometrie und Slots einmal aufbauen, bevor irgendetwas rendert. */
    uebernehmeFormat();
    if (geo) setzeSlotZahl(geo.anzahl);
    if (gespeichert && gespeichert.slots) setzeSlotZahl(Math.max(
      geo ? geo.anzahl : 1, Math.min(4, gespeichert.slots.length)));
    state.orientationInitialised = true;

    /* Ein Wechsler mit einer einzigen Leiste ist ein Schritt ohne Wahl. Solange
       die Kollektion nicht mehr hergibt, bleibt er aus — sobald sie gefuellt
       ist, erscheint er von allein. */
    var stepLeiste = $('sfc-step-leiste');
    if (stepLeiste) stepLeiste.hidden = leisten.length < 2;
    if (leisten.length < 2) {
      console.info('[SFC] Rahmenwechsler ausgeblendet — die eingestellte Kollektion ' +
        'enthält ' + leisten.length + ' Leiste(n). Ab zwei erscheint der Schritt von allein.');
    }

    /* Dasselbe fuer Format und Passepartout: bietet das Produkt nur eine Wahl,
       ist der Schritt eine Kachel ohne Entscheidung. Die Formatliste haengt an
       der Ausschnittzahl und kann sich spaeter aendern — deshalb wird sie in
       wechsle() erneut geprueft. */
    var stepFormat = $('sfc-step-format');
    if (stepFormat) stepFormat.hidden = groessenFuer(ppOptionVorhanden ? state.pp : null).length < 2;

    var stepMat = $('sfc-step-mat');
    if (stepMat) stepMat.hidden = !ppOptionVorhanden && SFC_MAT_COLORS.length < 2;

    /* Nummern erst hier vergeben: welche Schritte sichtbar sind, entscheidet
       sich aus Einstellungen und Datenlage. */
    nummeriereSchritte();

    // Erst jetzt steht fest, welche Schritte es gibt — die Leiste zieht nach.
    syncTabSichtbarkeit();
    syncTabs();

    renderChips();
    renderSlots();
    wechsle(state.groesseKey, state.pp, false);
    syncOrientationUi();
    renderLeisten();
    schreibeUrl(false);
    markiereBeispielAuswahl();
    updateDelivery();
    if (gespeichert) stelleBildWiederHer(gespeichert);

    /* Zurueck-Knopf: die Chronik traegt Format und Passepartout, sonst wird
       sie aus ?variant= der Zieladresse gelesen. */
    window.addEventListener('popstate', function (event) {
      var z = event.state;
      var wahl = (z && z.sfcGroesse) ? { groesse: z.sfcGroesse, pp: z.sfcPp }
                                     : wahlAusVariante(ausUrl() || startVariante);
      if (z && z.sfcLeiste && z.sfcLeiste !== state.leisteHandle) wechsleLeiste(z.sfcLeiste, false);
      if (z && typeof z.sfcQuer === 'boolean') state.wunschQuer = z.sfcQuer;
      if (!wahl.groesse) return;
      wechsle(wahl.groesse, ppOptionVorhanden ? (wahl.pp || state.pp) : null, false);
    });

    // Ausverkauft oder ohne bestellbare Variante: gar nicht erst konfigurieren lassen.
    var startV = aktuelleVariante();
    if (!startV || startV.verfuegbar === false) {
      els.atc.disabled = true;
      if (els.atcText) els.atcText.textContent = 'Derzeit nicht verfügbar';
      if (els.atcSub) els.atcSub.style.display = 'none';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Der Theme-Editor ersetzt das Section-Markup bei jeder Einstellungsaenderung.
  // Ohne diesen Listener waere der Konfigurator danach tot.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('#standard-frame-configurator')) {
      init();
    }
  });
})();
